/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
//
// THIS IS A GENERATED FILE
// DO NOT MODIFY IT! YOUR CHANGES WILL BE LOST
import {
  GrpcMessage,
  RecursivePartial,
  ToProtobufJSONOptions
} from '@ngx-grpc/common';
import { BinaryReader, BinaryWriter, ByteSource } from 'google-protobuf';
import * as googleType000 from '../../../external/mercury/v1/shared/google/type/decimal.pb';
import * as googleProtobuf001 from '@ngx-grpc/well-known-types';
import * as booking_platformV1Shared002 from '../../../external/mercury/v1/shared/cancellation-fee.pb';
import * as booking_platformV1Shared003 from '../../../external/mercury/v1/shared/phone.pb';
import * as booking_platformV1Shared004 from '../../../external/mercury/v1/shared/booking-question-form-element.pb';
import * as booking_platformV1Shared005 from '../../../external/mercury/v1/shared/guest-type.pb';
import * as booking_platformV1Shared006 from '../../../external/mercury/v1/shared/booking-status.pb';
import * as booking_platformV1Shared007 from '../../../external/mercury/v1/shared/product-option.pb';
import * as booking_platformV1Shared008 from '../../../external/mercury/v1/shared/cancellation-policy.pb';
import * as booking_platformV1Shared009 from '../../../external/mercury/v1/shared/seat.pb';
import * as booking_platformV1Shared010 from '../../../external/mercury/v1/shared/benefit-item.pb';
import * as booking_platformV1Shared011 from '../../../external/mercury/v1/shared/price-details.pb';
import * as booking_platformV1Shared012 from '../../../external/mercury/v1/shared/contact-info.pb';
import * as booking_platformV1Shared013 from '../../../external/mercury/v1/shared/payment-session.pb';
import * as booking_platformV1Shared014 from '../../../external/mercury/v1/shared/checkout-list-item.pb';
import * as booking_platformV1Shared015 from '../../../external/mercury/v1/shared/booking-question-answer.pb';
import * as booking_platformV1Shared016 from '../../../external/mercury/v1/shared/booking-question-validation-error.pb';
import * as booking_platformV1Shared017 from '../../../external/mercury/v1/shared/request-property-validation-error.pb';
import * as booking_platformV1Shared018 from '../../../external/mercury/v1/shared/booking-session-status.pb';
import * as booking_platformV1Shared019 from '../../../external/mercury/v1/shared/booking-component-detail.pb';
import * as booking_platformV1Shared020 from '../../../external/mercury/v1/shared/customer-cancellation-reason.pb';
import * as booking_platformV1Shared021 from '../../../external/mercury/v1/shared/cancellation-status.pb';
/**
 * Message implementation for booking_platform.v1.PreBookRequest
 */
export class PreBookRequest implements GrpcMessage {
  static id = 'booking_platform.v1.PreBookRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PreBookRequest();
    PreBookRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PreBookRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.optionToken = _instance.optionToken || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PreBookRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.optionToken = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PreBookRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PreBookRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.optionToken) {
      _writer.writeString(4, _instance.optionToken);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _optionToken: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PreBookRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PreBookRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.optionToken = _value.optionToken;
    PreBookRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get optionToken(): string {
    return this._optionToken;
  }
  set optionToken(value: string) {
    this._optionToken = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PreBookRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PreBookRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      optionToken: this.optionToken
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PreBookRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      optionToken: this.optionToken
    };
  }
}
export module PreBookRequest {
  /**
   * Standard JavaScript object representation for PreBookRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    optionToken: string;
  }

  /**
   * Protobuf JSON representation for PreBookRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    optionToken: string;
  }
}

/**
 * Message implementation for booking_platform.v1.PreBookResponse
 */
export class PreBookResponse implements GrpcMessage {
  static id = 'booking_platform.v1.PreBookResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PreBookResponse();
    PreBookResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PreBookResponse) {
    _instance.optionBookToken = _instance.optionBookToken || '';
    _instance.priceDetails = _instance.priceDetails || undefined;
    _instance.cancellationPolicy = _instance.cancellationPolicy || undefined;
    _instance.currencyCode = _instance.currencyCode || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PreBookResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.optionBookToken = _reader.readString();
          break;
        case 2:
          _instance.priceDetails = new booking_platformV1Shared011.PriceDetails();
          _reader.readMessage(
            _instance.priceDetails,
            booking_platformV1Shared011.PriceDetails.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.cancellationPolicy = new booking_platformV1Shared008.CancellationPolicy();
          _reader.readMessage(
            _instance.cancellationPolicy,
            booking_platformV1Shared008.CancellationPolicy
              .deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.currencyCode = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PreBookResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PreBookResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.optionBookToken) {
      _writer.writeString(1, _instance.optionBookToken);
    }
    if (_instance.priceDetails) {
      _writer.writeMessage(
        2,
        _instance.priceDetails as any,
        booking_platformV1Shared011.PriceDetails.serializeBinaryToWriter
      );
    }
    if (_instance.cancellationPolicy) {
      _writer.writeMessage(
        3,
        _instance.cancellationPolicy as any,
        booking_platformV1Shared008.CancellationPolicy.serializeBinaryToWriter
      );
    }
    if (_instance.currencyCode) {
      _writer.writeString(4, _instance.currencyCode);
    }
  }

  private _optionBookToken: string;
  private _priceDetails?: booking_platformV1Shared011.PriceDetails;
  private _cancellationPolicy?: booking_platformV1Shared008.CancellationPolicy;
  private _currencyCode: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PreBookResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PreBookResponse.AsObject>) {
    _value = _value || {};
    this.optionBookToken = _value.optionBookToken;
    this.priceDetails = _value.priceDetails
      ? new booking_platformV1Shared011.PriceDetails(_value.priceDetails)
      : undefined;
    this.cancellationPolicy = _value.cancellationPolicy
      ? new booking_platformV1Shared008.CancellationPolicy(
          _value.cancellationPolicy
        )
      : undefined;
    this.currencyCode = _value.currencyCode;
    PreBookResponse.refineValues(this);
  }
  get optionBookToken(): string {
    return this._optionBookToken;
  }
  set optionBookToken(value: string) {
    this._optionBookToken = value;
  }
  get priceDetails(): booking_platformV1Shared011.PriceDetails | undefined {
    return this._priceDetails;
  }
  set priceDetails(
    value: booking_platformV1Shared011.PriceDetails | undefined
  ) {
    this._priceDetails = value;
  }
  get cancellationPolicy():
    | booking_platformV1Shared008.CancellationPolicy
    | undefined {
    return this._cancellationPolicy;
  }
  set cancellationPolicy(
    value: booking_platformV1Shared008.CancellationPolicy | undefined
  ) {
    this._cancellationPolicy = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PreBookResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PreBookResponse.AsObject {
    return {
      optionBookToken: this.optionBookToken,
      priceDetails: this.priceDetails
        ? this.priceDetails.toObject()
        : undefined,
      cancellationPolicy: this.cancellationPolicy
        ? this.cancellationPolicy.toObject()
        : undefined,
      currencyCode: this.currencyCode
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PreBookResponse.AsProtobufJSON {
    return {
      optionBookToken: this.optionBookToken,
      priceDetails: this.priceDetails
        ? this.priceDetails.toProtobufJSON(options)
        : null,
      cancellationPolicy: this.cancellationPolicy
        ? this.cancellationPolicy.toProtobufJSON(options)
        : null,
      currencyCode: this.currencyCode
    };
  }
}
export module PreBookResponse {
  /**
   * Standard JavaScript object representation for PreBookResponse
   */
  export interface AsObject {
    optionBookToken: string;
    priceDetails?: booking_platformV1Shared011.PriceDetails.AsObject;
    cancellationPolicy?: booking_platformV1Shared008.CancellationPolicy.AsObject;
    currencyCode: string;
  }

  /**
   * Protobuf JSON representation for PreBookResponse
   */
  export interface AsProtobufJSON {
    optionBookToken: string;
    priceDetails: booking_platformV1Shared011.PriceDetails.AsProtobufJSON | null;
    cancellationPolicy: booking_platformV1Shared008.CancellationPolicy.AsProtobufJSON | null;
    currencyCode: string;
  }
}

/**
 * Message implementation for booking_platform.v1.CheckoutRequest
 */
export class CheckoutRequest implements GrpcMessage {
  static id = 'booking_platform.v1.CheckoutRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CheckoutRequest();
    CheckoutRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CheckoutRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.optionBookTokens = _instance.optionBookTokens || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CheckoutRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          (_instance.optionBookTokens = _instance.optionBookTokens || []).push(
            _reader.readString()
          );
          break;
        default:
          _reader.skipField();
      }
    }

    CheckoutRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CheckoutRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.optionBookTokens && _instance.optionBookTokens.length) {
      _writer.writeRepeatedString(4, _instance.optionBookTokens);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _optionBookTokens: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CheckoutRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CheckoutRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.optionBookTokens = (_value.optionBookTokens || []).slice();
    CheckoutRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get optionBookTokens(): string[] {
    return this._optionBookTokens;
  }
  set optionBookTokens(value: string[]) {
    this._optionBookTokens = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CheckoutRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CheckoutRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      optionBookTokens: (this.optionBookTokens || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CheckoutRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      optionBookTokens: (this.optionBookTokens || []).slice()
    };
  }
}
export module CheckoutRequest {
  /**
   * Standard JavaScript object representation for CheckoutRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    optionBookTokens: string[];
  }

  /**
   * Protobuf JSON representation for CheckoutRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    optionBookTokens: string[];
  }
}

/**
 * Message implementation for booking_platform.v1.CheckoutResponse
 */
export class CheckoutResponse implements GrpcMessage {
  static id = 'booking_platform.v1.CheckoutResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CheckoutResponse();
    CheckoutResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CheckoutResponse) {
    _instance.checkoutListItems = _instance.checkoutListItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CheckoutResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new booking_platformV1Shared014.CheckoutListItem();
          _reader.readMessage(
            messageInitializer1,
            booking_platformV1Shared014.CheckoutListItem
              .deserializeBinaryFromReader
          );
          (_instance.checkoutListItems =
            _instance.checkoutListItems || []).push(messageInitializer1);
          break;
        default:
          _reader.skipField();
      }
    }

    CheckoutResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CheckoutResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.checkoutListItems && _instance.checkoutListItems.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.checkoutListItems as any,
        booking_platformV1Shared014.CheckoutListItem.serializeBinaryToWriter
      );
    }
  }

  private _checkoutListItems?: booking_platformV1Shared014.CheckoutListItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CheckoutResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<CheckoutResponse.AsObject>) {
    _value = _value || {};
    this.checkoutListItems = (_value.checkoutListItems || []).map(
      m => new booking_platformV1Shared014.CheckoutListItem(m)
    );
    CheckoutResponse.refineValues(this);
  }
  get checkoutListItems():
    | booking_platformV1Shared014.CheckoutListItem[]
    | undefined {
    return this._checkoutListItems;
  }
  set checkoutListItems(
    value: booking_platformV1Shared014.CheckoutListItem[] | undefined
  ) {
    this._checkoutListItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CheckoutResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CheckoutResponse.AsObject {
    return {
      checkoutListItems: (this.checkoutListItems || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CheckoutResponse.AsProtobufJSON {
    return {
      checkoutListItems: (this.checkoutListItems || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module CheckoutResponse {
  /**
   * Standard JavaScript object representation for CheckoutResponse
   */
  export interface AsObject {
    checkoutListItems?: booking_platformV1Shared014.CheckoutListItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for CheckoutResponse
   */
  export interface AsProtobufJSON {
    checkoutListItems:
      | booking_platformV1Shared014.CheckoutListItem.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingValidationRequest
 */
export class BookingValidationRequest implements GrpcMessage {
  static id = 'booking_platform.v1.BookingValidationRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingValidationRequest();
    BookingValidationRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingValidationRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.optionToken = _instance.optionToken || '';
    _instance.contactInfo = _instance.contactInfo || undefined;
    _instance.bookingQuestionAnswers = _instance.bookingQuestionAnswers || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingValidationRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.optionToken = _reader.readString();
          break;
        case 5:
          _instance.contactInfo = new booking_platformV1Shared012.ContactInfo();
          _reader.readMessage(
            _instance.contactInfo,
            booking_platformV1Shared012.ContactInfo.deserializeBinaryFromReader
          );
          break;
        case 6:
          const messageInitializer6 = new booking_platformV1Shared015.BookingQuestionAnswer();
          _reader.readMessage(
            messageInitializer6,
            booking_platformV1Shared015.BookingQuestionAnswer
              .deserializeBinaryFromReader
          );
          (_instance.bookingQuestionAnswers =
            _instance.bookingQuestionAnswers || []).push(messageInitializer6);
          break;
        default:
          _reader.skipField();
      }
    }

    BookingValidationRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingValidationRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.optionToken) {
      _writer.writeString(4, _instance.optionToken);
    }
    if (_instance.contactInfo) {
      _writer.writeMessage(
        5,
        _instance.contactInfo as any,
        booking_platformV1Shared012.ContactInfo.serializeBinaryToWriter
      );
    }
    if (
      _instance.bookingQuestionAnswers &&
      _instance.bookingQuestionAnswers.length
    ) {
      _writer.writeRepeatedMessage(
        6,
        _instance.bookingQuestionAnswers as any,
        booking_platformV1Shared015.BookingQuestionAnswer
          .serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _optionToken: string;
  private _contactInfo?: booking_platformV1Shared012.ContactInfo;
  private _bookingQuestionAnswers?: booking_platformV1Shared015.BookingQuestionAnswer[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingValidationRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingValidationRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.optionToken = _value.optionToken;
    this.contactInfo = _value.contactInfo
      ? new booking_platformV1Shared012.ContactInfo(_value.contactInfo)
      : undefined;
    this.bookingQuestionAnswers = (_value.bookingQuestionAnswers || []).map(
      m => new booking_platformV1Shared015.BookingQuestionAnswer(m)
    );
    BookingValidationRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get optionToken(): string {
    return this._optionToken;
  }
  set optionToken(value: string) {
    this._optionToken = value;
  }
  get contactInfo(): booking_platformV1Shared012.ContactInfo | undefined {
    return this._contactInfo;
  }
  set contactInfo(value: booking_platformV1Shared012.ContactInfo | undefined) {
    this._contactInfo = value;
  }
  get bookingQuestionAnswers():
    | booking_platformV1Shared015.BookingQuestionAnswer[]
    | undefined {
    return this._bookingQuestionAnswers;
  }
  set bookingQuestionAnswers(
    value: booking_platformV1Shared015.BookingQuestionAnswer[] | undefined
  ) {
    this._bookingQuestionAnswers = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingValidationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingValidationRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      optionToken: this.optionToken,
      contactInfo: this.contactInfo ? this.contactInfo.toObject() : undefined,
      bookingQuestionAnswers: (this.bookingQuestionAnswers || []).map(m =>
        m.toObject()
      )
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingValidationRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      optionToken: this.optionToken,
      contactInfo: this.contactInfo
        ? this.contactInfo.toProtobufJSON(options)
        : null,
      bookingQuestionAnswers: (this.bookingQuestionAnswers || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module BookingValidationRequest {
  /**
   * Standard JavaScript object representation for BookingValidationRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    optionToken: string;
    contactInfo?: booking_platformV1Shared012.ContactInfo.AsObject;
    bookingQuestionAnswers?: booking_platformV1Shared015.BookingQuestionAnswer.AsObject[];
  }

  /**
   * Protobuf JSON representation for BookingValidationRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    optionToken: string;
    contactInfo: booking_platformV1Shared012.ContactInfo.AsProtobufJSON | null;
    bookingQuestionAnswers:
      | booking_platformV1Shared015.BookingQuestionAnswer.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingValidationResponse
 */
export class BookingValidationResponse implements GrpcMessage {
  static id = 'booking_platform.v1.BookingValidationResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingValidationResponse();
    BookingValidationResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingValidationResponse) {
    _instance.isValid = _instance.isValid || false;
    _instance.bookingQuestionValidationErrors =
      _instance.bookingQuestionValidationErrors || [];
    _instance.requestPropertyValidationErrors =
      _instance.requestPropertyValidationErrors || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingValidationResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.isValid = _reader.readBool();
          break;
        case 2:
          const messageInitializer2 = new booking_platformV1Shared016.BookingQuestionValidationError();
          _reader.readMessage(
            messageInitializer2,
            booking_platformV1Shared016.BookingQuestionValidationError
              .deserializeBinaryFromReader
          );
          (_instance.bookingQuestionValidationErrors =
            _instance.bookingQuestionValidationErrors || []).push(
            messageInitializer2
          );
          break;
        case 3:
          const messageInitializer3 = new booking_platformV1Shared017.RequestPropertyValidationError();
          _reader.readMessage(
            messageInitializer3,
            booking_platformV1Shared017.RequestPropertyValidationError
              .deserializeBinaryFromReader
          );
          (_instance.requestPropertyValidationErrors =
            _instance.requestPropertyValidationErrors || []).push(
            messageInitializer3
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingValidationResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingValidationResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.isValid) {
      _writer.writeBool(1, _instance.isValid);
    }
    if (
      _instance.bookingQuestionValidationErrors &&
      _instance.bookingQuestionValidationErrors.length
    ) {
      _writer.writeRepeatedMessage(
        2,
        _instance.bookingQuestionValidationErrors as any,
        booking_platformV1Shared016.BookingQuestionValidationError
          .serializeBinaryToWriter
      );
    }
    if (
      _instance.requestPropertyValidationErrors &&
      _instance.requestPropertyValidationErrors.length
    ) {
      _writer.writeRepeatedMessage(
        3,
        _instance.requestPropertyValidationErrors as any,
        booking_platformV1Shared017.RequestPropertyValidationError
          .serializeBinaryToWriter
      );
    }
  }

  private _isValid: boolean;
  private _bookingQuestionValidationErrors?: booking_platformV1Shared016.BookingQuestionValidationError[];
  private _requestPropertyValidationErrors?: booking_platformV1Shared017.RequestPropertyValidationError[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingValidationResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingValidationResponse.AsObject>) {
    _value = _value || {};
    this.isValid = _value.isValid;
    this.bookingQuestionValidationErrors = (
      _value.bookingQuestionValidationErrors || []
    ).map(
      m => new booking_platformV1Shared016.BookingQuestionValidationError(m)
    );
    this.requestPropertyValidationErrors = (
      _value.requestPropertyValidationErrors || []
    ).map(
      m => new booking_platformV1Shared017.RequestPropertyValidationError(m)
    );
    BookingValidationResponse.refineValues(this);
  }
  get isValid(): boolean {
    return this._isValid;
  }
  set isValid(value: boolean) {
    this._isValid = value;
  }
  get bookingQuestionValidationErrors():
    | booking_platformV1Shared016.BookingQuestionValidationError[]
    | undefined {
    return this._bookingQuestionValidationErrors;
  }
  set bookingQuestionValidationErrors(
    value:
      | booking_platformV1Shared016.BookingQuestionValidationError[]
      | undefined
  ) {
    this._bookingQuestionValidationErrors = value;
  }
  get requestPropertyValidationErrors():
    | booking_platformV1Shared017.RequestPropertyValidationError[]
    | undefined {
    return this._requestPropertyValidationErrors;
  }
  set requestPropertyValidationErrors(
    value:
      | booking_platformV1Shared017.RequestPropertyValidationError[]
      | undefined
  ) {
    this._requestPropertyValidationErrors = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingValidationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingValidationResponse.AsObject {
    return {
      isValid: this.isValid,
      bookingQuestionValidationErrors: (
        this.bookingQuestionValidationErrors || []
      ).map(m => m.toObject()),
      requestPropertyValidationErrors: (
        this.requestPropertyValidationErrors || []
      ).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingValidationResponse.AsProtobufJSON {
    return {
      isValid: this.isValid,
      bookingQuestionValidationErrors: (
        this.bookingQuestionValidationErrors || []
      ).map(m => m.toProtobufJSON(options)),
      requestPropertyValidationErrors: (
        this.requestPropertyValidationErrors || []
      ).map(m => m.toProtobufJSON(options))
    };
  }
}
export module BookingValidationResponse {
  /**
   * Standard JavaScript object representation for BookingValidationResponse
   */
  export interface AsObject {
    isValid: boolean;
    bookingQuestionValidationErrors?: booking_platformV1Shared016.BookingQuestionValidationError.AsObject[];
    requestPropertyValidationErrors?: booking_platformV1Shared017.RequestPropertyValidationError.AsObject[];
  }

  /**
   * Protobuf JSON representation for BookingValidationResponse
   */
  export interface AsProtobufJSON {
    isValid: boolean;
    bookingQuestionValidationErrors:
      | booking_platformV1Shared016.BookingQuestionValidationError.AsProtobufJSON[]
      | null;
    requestPropertyValidationErrors:
      | booking_platformV1Shared017.RequestPropertyValidationError.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.CheckBookingSessionStatusRequest
 */
export class CheckBookingSessionStatusRequest implements GrpcMessage {
  static id = 'booking_platform.v1.CheckBookingSessionStatusRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CheckBookingSessionStatusRequest();
    CheckBookingSessionStatusRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CheckBookingSessionStatusRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.bookingSessionId = _instance.bookingSessionId || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CheckBookingSessionStatusRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.bookingSessionId = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CheckBookingSessionStatusRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CheckBookingSessionStatusRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.bookingSessionId) {
      _writer.writeString(4, _instance.bookingSessionId);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _bookingSessionId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CheckBookingSessionStatusRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<CheckBookingSessionStatusRequest.AsObject>
  ) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.bookingSessionId = _value.bookingSessionId;
    CheckBookingSessionStatusRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get bookingSessionId(): string {
    return this._bookingSessionId;
  }
  set bookingSessionId(value: string) {
    this._bookingSessionId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CheckBookingSessionStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CheckBookingSessionStatusRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingSessionId: this.bookingSessionId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CheckBookingSessionStatusRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingSessionId: this.bookingSessionId
    };
  }
}
export module CheckBookingSessionStatusRequest {
  /**
   * Standard JavaScript object representation for CheckBookingSessionStatusRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingSessionId: string;
  }

  /**
   * Protobuf JSON representation for CheckBookingSessionStatusRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingSessionId: string;
  }
}

/**
 * Message implementation for booking_platform.v1.CheckBookingSessionStatusResponse
 */
export class CheckBookingSessionStatusResponse implements GrpcMessage {
  static id = 'booking_platform.v1.CheckBookingSessionStatusResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CheckBookingSessionStatusResponse();
    CheckBookingSessionStatusResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CheckBookingSessionStatusResponse) {
    _instance.bookingStatus = _instance.bookingStatus || 0;
    _instance.bookingReference = _instance.bookingReference || undefined;
    _instance.errorMessage = _instance.errorMessage || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CheckBookingSessionStatusResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingStatus = _reader.readEnum();
          break;
        case 2:
          _instance.bookingReference = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.bookingReference,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.errorMessage = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.errorMessage,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    CheckBookingSessionStatusResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CheckBookingSessionStatusResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingStatus) {
      _writer.writeEnum(1, _instance.bookingStatus);
    }
    if (_instance.bookingReference) {
      _writer.writeMessage(
        2,
        _instance.bookingReference as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.errorMessage) {
      _writer.writeMessage(
        3,
        _instance.errorMessage as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _bookingStatus: booking_platformV1Shared018.BookingSessionStatus;
  private _bookingReference?: googleProtobuf001.StringValue;
  private _errorMessage?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CheckBookingSessionStatusResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<CheckBookingSessionStatusResponse.AsObject>
  ) {
    _value = _value || {};
    this.bookingStatus = _value.bookingStatus;
    this.bookingReference = _value.bookingReference
      ? new googleProtobuf001.StringValue(_value.bookingReference)
      : undefined;
    this.errorMessage = _value.errorMessage
      ? new googleProtobuf001.StringValue(_value.errorMessage)
      : undefined;
    CheckBookingSessionStatusResponse.refineValues(this);
  }
  get bookingStatus(): booking_platformV1Shared018.BookingSessionStatus {
    return this._bookingStatus;
  }
  set bookingStatus(value: booking_platformV1Shared018.BookingSessionStatus) {
    this._bookingStatus = value;
  }
  get bookingReference(): googleProtobuf001.StringValue | undefined {
    return this._bookingReference;
  }
  set bookingReference(value: googleProtobuf001.StringValue | undefined) {
    this._bookingReference = value;
  }
  get errorMessage(): googleProtobuf001.StringValue | undefined {
    return this._errorMessage;
  }
  set errorMessage(value: googleProtobuf001.StringValue | undefined) {
    this._errorMessage = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CheckBookingSessionStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CheckBookingSessionStatusResponse.AsObject {
    return {
      bookingStatus: this.bookingStatus,
      bookingReference: this.bookingReference
        ? this.bookingReference.toObject()
        : undefined,
      errorMessage: this.errorMessage ? this.errorMessage.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CheckBookingSessionStatusResponse.AsProtobufJSON {
    return {
      bookingStatus:
        booking_platformV1Shared018.BookingSessionStatus[
          this.bookingStatus === null || this.bookingStatus === undefined
            ? 0
            : this.bookingStatus
        ],
      bookingReference: this.bookingReference
        ? this.bookingReference.toProtobufJSON(options)
        : null,
      errorMessage: this.errorMessage
        ? this.errorMessage.toProtobufJSON(options)
        : null
    };
  }
}
export module CheckBookingSessionStatusResponse {
  /**
   * Standard JavaScript object representation for CheckBookingSessionStatusResponse
   */
  export interface AsObject {
    bookingStatus: booking_platformV1Shared018.BookingSessionStatus;
    bookingReference?: googleProtobuf001.StringValue.AsObject;
    errorMessage?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for CheckBookingSessionStatusResponse
   */
  export interface AsProtobufJSON {
    bookingStatus: string;
    bookingReference: googleProtobuf001.StringValue.AsProtobufJSON | null;
    errorMessage: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingDetailsRequest
 */
export class BookingDetailsRequest implements GrpcMessage {
  static id = 'booking_platform.v1.BookingDetailsRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingDetailsRequest();
    BookingDetailsRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingDetailsRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.bookingReferences = _instance.bookingReferences || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingDetailsRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          (_instance.bookingReferences =
            _instance.bookingReferences || []).push(_reader.readString());
          break;
        default:
          _reader.skipField();
      }
    }

    BookingDetailsRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingDetailsRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.bookingReferences && _instance.bookingReferences.length) {
      _writer.writeRepeatedString(4, _instance.bookingReferences);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _bookingReferences: string[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingDetailsRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingDetailsRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.bookingReferences = (_value.bookingReferences || []).slice();
    BookingDetailsRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get bookingReferences(): string[] {
    return this._bookingReferences;
  }
  set bookingReferences(value: string[]) {
    this._bookingReferences = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingDetailsRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingReferences: (this.bookingReferences || []).slice()
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingDetailsRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingReferences: (this.bookingReferences || []).slice()
    };
  }
}
export module BookingDetailsRequest {
  /**
   * Standard JavaScript object representation for BookingDetailsRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingReferences: string[];
  }

  /**
   * Protobuf JSON representation for BookingDetailsRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingReferences: string[];
  }
}

/**
 * Message implementation for booking_platform.v1.BookingDetailsResponse
 */
export class BookingDetailsResponse implements GrpcMessage {
  static id = 'booking_platform.v1.BookingDetailsResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingDetailsResponse();
    BookingDetailsResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingDetailsResponse) {
    _instance.bookingDetailsResponseItems =
      _instance.bookingDetailsResponseItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingDetailsResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new BookingDetailsResponseItem();
          _reader.readMessage(
            messageInitializer1,
            BookingDetailsResponseItem.deserializeBinaryFromReader
          );
          (_instance.bookingDetailsResponseItems =
            _instance.bookingDetailsResponseItems || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingDetailsResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingDetailsResponse,
    _writer: BinaryWriter
  ) {
    if (
      _instance.bookingDetailsResponseItems &&
      _instance.bookingDetailsResponseItems.length
    ) {
      _writer.writeRepeatedMessage(
        1,
        _instance.bookingDetailsResponseItems as any,
        BookingDetailsResponseItem.serializeBinaryToWriter
      );
    }
  }

  private _bookingDetailsResponseItems?: BookingDetailsResponseItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingDetailsResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingDetailsResponse.AsObject>) {
    _value = _value || {};
    this.bookingDetailsResponseItems = (
      _value.bookingDetailsResponseItems || []
    ).map(m => new BookingDetailsResponseItem(m));
    BookingDetailsResponse.refineValues(this);
  }
  get bookingDetailsResponseItems(): BookingDetailsResponseItem[] | undefined {
    return this._bookingDetailsResponseItems;
  }
  set bookingDetailsResponseItems(
    value: BookingDetailsResponseItem[] | undefined
  ) {
    this._bookingDetailsResponseItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingDetailsResponse.AsObject {
    return {
      bookingDetailsResponseItems: (
        this.bookingDetailsResponseItems || []
      ).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingDetailsResponse.AsProtobufJSON {
    return {
      bookingDetailsResponseItems: (
        this.bookingDetailsResponseItems || []
      ).map(m => m.toProtobufJSON(options))
    };
  }
}
export module BookingDetailsResponse {
  /**
   * Standard JavaScript object representation for BookingDetailsResponse
   */
  export interface AsObject {
    bookingDetailsResponseItems?: BookingDetailsResponseItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for BookingDetailsResponse
   */
  export interface AsProtobufJSON {
    bookingDetailsResponseItems:
      | BookingDetailsResponseItem.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingDetailsResponseItem
 */
export class BookingDetailsResponseItem implements GrpcMessage {
  static id = 'booking_platform.v1.BookingDetailsResponseItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingDetailsResponseItem();
    BookingDetailsResponseItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingDetailsResponseItem) {
    _instance.clientName = _instance.clientName || '';
    _instance.brandName = _instance.brandName || '';
    _instance.salesChannelName = _instance.salesChannelName || '';
    _instance.status = _instance.status || 0;
    _instance.partnerBookingReference =
      _instance.partnerBookingReference || undefined;
    _instance.bookingDate = _instance.bookingDate || '';
    _instance.customerFirstName = _instance.customerFirstName || '';
    _instance.customerLastName = _instance.customerLastName || '';
    _instance.customerEmailAddress = _instance.customerEmailAddress || '';
    _instance.customerPhoneNumber = _instance.customerPhoneNumber || '';
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.totalPrice = _instance.totalPrice || undefined;
    _instance.originalTotalPrice = _instance.originalTotalPrice || undefined;
    _instance.paidAmount = _instance.paidAmount || undefined;
    _instance.refundAmount = _instance.refundAmount || undefined;
    _instance.bookingComponentDetails = _instance.bookingComponentDetails || [];
    _instance.bookingReference = _instance.bookingReference || '';
    _instance.userId = _instance.userId || undefined;
    _instance.createdBy = _instance.createdBy || undefined;
    _instance.customerAddress = _instance.customerAddress || undefined;
    _instance.customerZipCode = _instance.customerZipCode || undefined;
    _instance.customerCountry = _instance.customerCountry || undefined;
    _instance.customerCity = _instance.customerCity || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingDetailsResponseItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.clientName = _reader.readString();
          break;
        case 2:
          _instance.brandName = _reader.readString();
          break;
        case 3:
          _instance.salesChannelName = _reader.readString();
          break;
        case 4:
          _instance.status = _reader.readEnum();
          break;
        case 5:
          _instance.partnerBookingReference = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.partnerBookingReference,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.bookingDate = _reader.readString();
          break;
        case 7:
          _instance.customerFirstName = _reader.readString();
          break;
        case 8:
          _instance.customerLastName = _reader.readString();
          break;
        case 9:
          _instance.customerEmailAddress = _reader.readString();
          break;
        case 10:
          _instance.customerPhoneNumber = _reader.readString();
          break;
        case 11:
          _instance.currencyCode = _reader.readString();
          break;
        case 12:
          _instance.totalPrice = new googleType000.Decimal();
          _reader.readMessage(
            _instance.totalPrice,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.originalTotalPrice = new googleType000.Decimal();
          _reader.readMessage(
            _instance.originalTotalPrice,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 14:
          _instance.paidAmount = new googleType000.Decimal();
          _reader.readMessage(
            _instance.paidAmount,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 15:
          _instance.refundAmount = new googleType000.Decimal();
          _reader.readMessage(
            _instance.refundAmount,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 16:
          const messageInitializer16 = new booking_platformV1Shared019.BookingComponentDetail();
          _reader.readMessage(
            messageInitializer16,
            booking_platformV1Shared019.BookingComponentDetail
              .deserializeBinaryFromReader
          );
          (_instance.bookingComponentDetails =
            _instance.bookingComponentDetails || []).push(messageInitializer16);
          break;
        case 17:
          _instance.bookingReference = _reader.readString();
          break;
        case 18:
          _instance.userId = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.userId,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 19:
          _instance.createdBy = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.createdBy,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 20:
          _instance.customerAddress = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.customerAddress,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 21:
          _instance.customerZipCode = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.customerZipCode,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 22:
          _instance.customerCountry = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.customerCountry,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 23:
          _instance.customerCity = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.customerCity,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingDetailsResponseItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingDetailsResponseItem,
    _writer: BinaryWriter
  ) {
    if (_instance.clientName) {
      _writer.writeString(1, _instance.clientName);
    }
    if (_instance.brandName) {
      _writer.writeString(2, _instance.brandName);
    }
    if (_instance.salesChannelName) {
      _writer.writeString(3, _instance.salesChannelName);
    }
    if (_instance.status) {
      _writer.writeEnum(4, _instance.status);
    }
    if (_instance.partnerBookingReference) {
      _writer.writeMessage(
        5,
        _instance.partnerBookingReference as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.bookingDate) {
      _writer.writeString(6, _instance.bookingDate);
    }
    if (_instance.customerFirstName) {
      _writer.writeString(7, _instance.customerFirstName);
    }
    if (_instance.customerLastName) {
      _writer.writeString(8, _instance.customerLastName);
    }
    if (_instance.customerEmailAddress) {
      _writer.writeString(9, _instance.customerEmailAddress);
    }
    if (_instance.customerPhoneNumber) {
      _writer.writeString(10, _instance.customerPhoneNumber);
    }
    if (_instance.currencyCode) {
      _writer.writeString(11, _instance.currencyCode);
    }
    if (_instance.totalPrice) {
      _writer.writeMessage(
        12,
        _instance.totalPrice as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.originalTotalPrice) {
      _writer.writeMessage(
        13,
        _instance.originalTotalPrice as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.paidAmount) {
      _writer.writeMessage(
        14,
        _instance.paidAmount as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (_instance.refundAmount) {
      _writer.writeMessage(
        15,
        _instance.refundAmount as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (
      _instance.bookingComponentDetails &&
      _instance.bookingComponentDetails.length
    ) {
      _writer.writeRepeatedMessage(
        16,
        _instance.bookingComponentDetails as any,
        booking_platformV1Shared019.BookingComponentDetail
          .serializeBinaryToWriter
      );
    }
    if (_instance.bookingReference) {
      _writer.writeString(17, _instance.bookingReference);
    }
    if (_instance.userId) {
      _writer.writeMessage(
        18,
        _instance.userId as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.createdBy) {
      _writer.writeMessage(
        19,
        _instance.createdBy as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.customerAddress) {
      _writer.writeMessage(
        20,
        _instance.customerAddress as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.customerZipCode) {
      _writer.writeMessage(
        21,
        _instance.customerZipCode as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.customerCountry) {
      _writer.writeMessage(
        22,
        _instance.customerCountry as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.customerCity) {
      _writer.writeMessage(
        23,
        _instance.customerCity as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _clientName: string;
  private _brandName: string;
  private _salesChannelName: string;
  private _status: booking_platformV1Shared006.BookingStatus;
  private _partnerBookingReference?: googleProtobuf001.StringValue;
  private _bookingDate: string;
  private _customerFirstName: string;
  private _customerLastName: string;
  private _customerEmailAddress: string;
  private _customerPhoneNumber: string;
  private _currencyCode: string;
  private _totalPrice?: googleType000.Decimal;
  private _originalTotalPrice?: googleType000.Decimal;
  private _paidAmount?: googleType000.Decimal;
  private _refundAmount?: googleType000.Decimal;
  private _bookingComponentDetails?: booking_platformV1Shared019.BookingComponentDetail[];
  private _bookingReference: string;
  private _userId?: googleProtobuf001.Int32Value;
  private _createdBy?: googleProtobuf001.StringValue;
  private _customerAddress?: googleProtobuf001.StringValue;
  private _customerZipCode?: googleProtobuf001.StringValue;
  private _customerCountry?: googleProtobuf001.StringValue;
  private _customerCity?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingDetailsResponseItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingDetailsResponseItem.AsObject>) {
    _value = _value || {};
    this.clientName = _value.clientName;
    this.brandName = _value.brandName;
    this.salesChannelName = _value.salesChannelName;
    this.status = _value.status;
    this.partnerBookingReference = _value.partnerBookingReference
      ? new googleProtobuf001.StringValue(_value.partnerBookingReference)
      : undefined;
    this.bookingDate = _value.bookingDate;
    this.customerFirstName = _value.customerFirstName;
    this.customerLastName = _value.customerLastName;
    this.customerEmailAddress = _value.customerEmailAddress;
    this.customerPhoneNumber = _value.customerPhoneNumber;
    this.currencyCode = _value.currencyCode;
    this.totalPrice = _value.totalPrice
      ? new googleType000.Decimal(_value.totalPrice)
      : undefined;
    this.originalTotalPrice = _value.originalTotalPrice
      ? new googleType000.Decimal(_value.originalTotalPrice)
      : undefined;
    this.paidAmount = _value.paidAmount
      ? new googleType000.Decimal(_value.paidAmount)
      : undefined;
    this.refundAmount = _value.refundAmount
      ? new googleType000.Decimal(_value.refundAmount)
      : undefined;
    this.bookingComponentDetails = (_value.bookingComponentDetails || []).map(
      m => new booking_platformV1Shared019.BookingComponentDetail(m)
    );
    this.bookingReference = _value.bookingReference;
    this.userId = _value.userId
      ? new googleProtobuf001.Int32Value(_value.userId)
      : undefined;
    this.createdBy = _value.createdBy
      ? new googleProtobuf001.StringValue(_value.createdBy)
      : undefined;
    this.customerAddress = _value.customerAddress
      ? new googleProtobuf001.StringValue(_value.customerAddress)
      : undefined;
    this.customerZipCode = _value.customerZipCode
      ? new googleProtobuf001.StringValue(_value.customerZipCode)
      : undefined;
    this.customerCountry = _value.customerCountry
      ? new googleProtobuf001.StringValue(_value.customerCountry)
      : undefined;
    this.customerCity = _value.customerCity
      ? new googleProtobuf001.StringValue(_value.customerCity)
      : undefined;
    BookingDetailsResponseItem.refineValues(this);
  }
  get clientName(): string {
    return this._clientName;
  }
  set clientName(value: string) {
    this._clientName = value;
  }
  get brandName(): string {
    return this._brandName;
  }
  set brandName(value: string) {
    this._brandName = value;
  }
  get salesChannelName(): string {
    return this._salesChannelName;
  }
  set salesChannelName(value: string) {
    this._salesChannelName = value;
  }
  get status(): booking_platformV1Shared006.BookingStatus {
    return this._status;
  }
  set status(value: booking_platformV1Shared006.BookingStatus) {
    this._status = value;
  }
  get partnerBookingReference(): googleProtobuf001.StringValue | undefined {
    return this._partnerBookingReference;
  }
  set partnerBookingReference(
    value: googleProtobuf001.StringValue | undefined
  ) {
    this._partnerBookingReference = value;
  }
  get bookingDate(): string {
    return this._bookingDate;
  }
  set bookingDate(value: string) {
    this._bookingDate = value;
  }
  get customerFirstName(): string {
    return this._customerFirstName;
  }
  set customerFirstName(value: string) {
    this._customerFirstName = value;
  }
  get customerLastName(): string {
    return this._customerLastName;
  }
  set customerLastName(value: string) {
    this._customerLastName = value;
  }
  get customerEmailAddress(): string {
    return this._customerEmailAddress;
  }
  set customerEmailAddress(value: string) {
    this._customerEmailAddress = value;
  }
  get customerPhoneNumber(): string {
    return this._customerPhoneNumber;
  }
  set customerPhoneNumber(value: string) {
    this._customerPhoneNumber = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get totalPrice(): googleType000.Decimal | undefined {
    return this._totalPrice;
  }
  set totalPrice(value: googleType000.Decimal | undefined) {
    this._totalPrice = value;
  }
  get originalTotalPrice(): googleType000.Decimal | undefined {
    return this._originalTotalPrice;
  }
  set originalTotalPrice(value: googleType000.Decimal | undefined) {
    this._originalTotalPrice = value;
  }
  get paidAmount(): googleType000.Decimal | undefined {
    return this._paidAmount;
  }
  set paidAmount(value: googleType000.Decimal | undefined) {
    this._paidAmount = value;
  }
  get refundAmount(): googleType000.Decimal | undefined {
    return this._refundAmount;
  }
  set refundAmount(value: googleType000.Decimal | undefined) {
    this._refundAmount = value;
  }
  get bookingComponentDetails():
    | booking_platformV1Shared019.BookingComponentDetail[]
    | undefined {
    return this._bookingComponentDetails;
  }
  set bookingComponentDetails(
    value: booking_platformV1Shared019.BookingComponentDetail[] | undefined
  ) {
    this._bookingComponentDetails = value;
  }
  get bookingReference(): string {
    return this._bookingReference;
  }
  set bookingReference(value: string) {
    this._bookingReference = value;
  }
  get userId(): googleProtobuf001.Int32Value | undefined {
    return this._userId;
  }
  set userId(value: googleProtobuf001.Int32Value | undefined) {
    this._userId = value;
  }
  get createdBy(): googleProtobuf001.StringValue | undefined {
    return this._createdBy;
  }
  set createdBy(value: googleProtobuf001.StringValue | undefined) {
    this._createdBy = value;
  }
  get customerAddress(): googleProtobuf001.StringValue | undefined {
    return this._customerAddress;
  }
  set customerAddress(value: googleProtobuf001.StringValue | undefined) {
    this._customerAddress = value;
  }
  get customerZipCode(): googleProtobuf001.StringValue | undefined {
    return this._customerZipCode;
  }
  set customerZipCode(value: googleProtobuf001.StringValue | undefined) {
    this._customerZipCode = value;
  }
  get customerCountry(): googleProtobuf001.StringValue | undefined {
    return this._customerCountry;
  }
  set customerCountry(value: googleProtobuf001.StringValue | undefined) {
    this._customerCountry = value;
  }
  get customerCity(): googleProtobuf001.StringValue | undefined {
    return this._customerCity;
  }
  set customerCity(value: googleProtobuf001.StringValue | undefined) {
    this._customerCity = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingDetailsResponseItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingDetailsResponseItem.AsObject {
    return {
      clientName: this.clientName,
      brandName: this.brandName,
      salesChannelName: this.salesChannelName,
      status: this.status,
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toObject()
        : undefined,
      bookingDate: this.bookingDate,
      customerFirstName: this.customerFirstName,
      customerLastName: this.customerLastName,
      customerEmailAddress: this.customerEmailAddress,
      customerPhoneNumber: this.customerPhoneNumber,
      currencyCode: this.currencyCode,
      totalPrice: this.totalPrice ? this.totalPrice.toObject() : undefined,
      originalTotalPrice: this.originalTotalPrice
        ? this.originalTotalPrice.toObject()
        : undefined,
      paidAmount: this.paidAmount ? this.paidAmount.toObject() : undefined,
      refundAmount: this.refundAmount
        ? this.refundAmount.toObject()
        : undefined,
      bookingComponentDetails: (this.bookingComponentDetails || []).map(m =>
        m.toObject()
      ),
      bookingReference: this.bookingReference,
      userId: this.userId ? this.userId.toObject() : undefined,
      createdBy: this.createdBy ? this.createdBy.toObject() : undefined,
      customerAddress: this.customerAddress
        ? this.customerAddress.toObject()
        : undefined,
      customerZipCode: this.customerZipCode
        ? this.customerZipCode.toObject()
        : undefined,
      customerCountry: this.customerCountry
        ? this.customerCountry.toObject()
        : undefined,
      customerCity: this.customerCity ? this.customerCity.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingDetailsResponseItem.AsProtobufJSON {
    return {
      clientName: this.clientName,
      brandName: this.brandName,
      salesChannelName: this.salesChannelName,
      status:
        booking_platformV1Shared006.BookingStatus[
          this.status === null || this.status === undefined ? 0 : this.status
        ],
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toProtobufJSON(options)
        : null,
      bookingDate: this.bookingDate,
      customerFirstName: this.customerFirstName,
      customerLastName: this.customerLastName,
      customerEmailAddress: this.customerEmailAddress,
      customerPhoneNumber: this.customerPhoneNumber,
      currencyCode: this.currencyCode,
      totalPrice: this.totalPrice
        ? this.totalPrice.toProtobufJSON(options)
        : null,
      originalTotalPrice: this.originalTotalPrice
        ? this.originalTotalPrice.toProtobufJSON(options)
        : null,
      paidAmount: this.paidAmount
        ? this.paidAmount.toProtobufJSON(options)
        : null,
      refundAmount: this.refundAmount
        ? this.refundAmount.toProtobufJSON(options)
        : null,
      bookingComponentDetails: (this.bookingComponentDetails || []).map(m =>
        m.toProtobufJSON(options)
      ),
      bookingReference: this.bookingReference,
      userId: this.userId ? this.userId.toProtobufJSON(options) : null,
      createdBy: this.createdBy ? this.createdBy.toProtobufJSON(options) : null,
      customerAddress: this.customerAddress
        ? this.customerAddress.toProtobufJSON(options)
        : null,
      customerZipCode: this.customerZipCode
        ? this.customerZipCode.toProtobufJSON(options)
        : null,
      customerCountry: this.customerCountry
        ? this.customerCountry.toProtobufJSON(options)
        : null,
      customerCity: this.customerCity
        ? this.customerCity.toProtobufJSON(options)
        : null
    };
  }
}
export module BookingDetailsResponseItem {
  /**
   * Standard JavaScript object representation for BookingDetailsResponseItem
   */
  export interface AsObject {
    clientName: string;
    brandName: string;
    salesChannelName: string;
    status: booking_platformV1Shared006.BookingStatus;
    partnerBookingReference?: googleProtobuf001.StringValue.AsObject;
    bookingDate: string;
    customerFirstName: string;
    customerLastName: string;
    customerEmailAddress: string;
    customerPhoneNumber: string;
    currencyCode: string;
    totalPrice?: googleType000.Decimal.AsObject;
    originalTotalPrice?: googleType000.Decimal.AsObject;
    paidAmount?: googleType000.Decimal.AsObject;
    refundAmount?: googleType000.Decimal.AsObject;
    bookingComponentDetails?: booking_platformV1Shared019.BookingComponentDetail.AsObject[];
    bookingReference: string;
    userId?: googleProtobuf001.Int32Value.AsObject;
    createdBy?: googleProtobuf001.StringValue.AsObject;
    customerAddress?: googleProtobuf001.StringValue.AsObject;
    customerZipCode?: googleProtobuf001.StringValue.AsObject;
    customerCountry?: googleProtobuf001.StringValue.AsObject;
    customerCity?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for BookingDetailsResponseItem
   */
  export interface AsProtobufJSON {
    clientName: string;
    brandName: string;
    salesChannelName: string;
    status: string;
    partnerBookingReference: googleProtobuf001.StringValue.AsProtobufJSON | null;
    bookingDate: string;
    customerFirstName: string;
    customerLastName: string;
    customerEmailAddress: string;
    customerPhoneNumber: string;
    currencyCode: string;
    totalPrice: googleType000.Decimal.AsProtobufJSON | null;
    originalTotalPrice: googleType000.Decimal.AsProtobufJSON | null;
    paidAmount: googleType000.Decimal.AsProtobufJSON | null;
    refundAmount: googleType000.Decimal.AsProtobufJSON | null;
    bookingComponentDetails:
      | booking_platformV1Shared019.BookingComponentDetail.AsProtobufJSON[]
      | null;
    bookingReference: string;
    userId: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    createdBy: googleProtobuf001.StringValue.AsProtobufJSON | null;
    customerAddress: googleProtobuf001.StringValue.AsProtobufJSON | null;
    customerZipCode: googleProtobuf001.StringValue.AsProtobufJSON | null;
    customerCountry: googleProtobuf001.StringValue.AsProtobufJSON | null;
    customerCity: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.PreCancelRequest
 */
export class PreCancelRequest implements GrpcMessage {
  static id = 'booking_platform.v1.PreCancelRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PreCancelRequest();
    PreCancelRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PreCancelRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.bookingReference = _instance.bookingReference || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PreCancelRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.bookingReference = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    PreCancelRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PreCancelRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.bookingReference) {
      _writer.writeString(4, _instance.bookingReference);
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _bookingReference: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PreCancelRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<PreCancelRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.bookingReference = _value.bookingReference;
    PreCancelRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get bookingReference(): string {
    return this._bookingReference;
  }
  set bookingReference(value: string) {
    this._bookingReference = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PreCancelRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PreCancelRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingReference: this.bookingReference
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PreCancelRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingReference: this.bookingReference
    };
  }
}
export module PreCancelRequest {
  /**
   * Standard JavaScript object representation for PreCancelRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingReference: string;
  }

  /**
   * Protobuf JSON representation for PreCancelRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingReference: string;
  }
}

/**
 * Message implementation for booking_platform.v1.PreCancelResponse
 */
export class PreCancelResponse implements GrpcMessage {
  static id = 'booking_platform.v1.PreCancelResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new PreCancelResponse();
    PreCancelResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: PreCancelResponse) {
    _instance.bookingReference = _instance.bookingReference || '';
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.bookingComponents = _instance.bookingComponents || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: PreCancelResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingReference = _reader.readString();
          break;
        case 2:
          _instance.currencyCode = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new BookingComponent();
          _reader.readMessage(
            messageInitializer3,
            BookingComponent.deserializeBinaryFromReader
          );
          (_instance.bookingComponents =
            _instance.bookingComponents || []).push(messageInitializer3);
          break;
        default:
          _reader.skipField();
      }
    }

    PreCancelResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: PreCancelResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingReference) {
      _writer.writeString(1, _instance.bookingReference);
    }
    if (_instance.currencyCode) {
      _writer.writeString(2, _instance.currencyCode);
    }
    if (_instance.bookingComponents && _instance.bookingComponents.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.bookingComponents as any,
        BookingComponent.serializeBinaryToWriter
      );
    }
  }

  private _bookingReference: string;
  private _currencyCode: string;
  private _bookingComponents?: BookingComponent[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of PreCancelResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<PreCancelResponse.AsObject>) {
    _value = _value || {};
    this.bookingReference = _value.bookingReference;
    this.currencyCode = _value.currencyCode;
    this.bookingComponents = (_value.bookingComponents || []).map(
      m => new BookingComponent(m)
    );
    PreCancelResponse.refineValues(this);
  }
  get bookingReference(): string {
    return this._bookingReference;
  }
  set bookingReference(value: string) {
    this._bookingReference = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get bookingComponents(): BookingComponent[] | undefined {
    return this._bookingComponents;
  }
  set bookingComponents(value: BookingComponent[] | undefined) {
    this._bookingComponents = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    PreCancelResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): PreCancelResponse.AsObject {
    return {
      bookingReference: this.bookingReference,
      currencyCode: this.currencyCode,
      bookingComponents: (this.bookingComponents || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): PreCancelResponse.AsProtobufJSON {
    return {
      bookingReference: this.bookingReference,
      currencyCode: this.currencyCode,
      bookingComponents: (this.bookingComponents || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module PreCancelResponse {
  /**
   * Standard JavaScript object representation for PreCancelResponse
   */
  export interface AsObject {
    bookingReference: string;
    currencyCode: string;
    bookingComponents?: BookingComponent.AsObject[];
  }

  /**
   * Protobuf JSON representation for PreCancelResponse
   */
  export interface AsProtobufJSON {
    bookingReference: string;
    currencyCode: string;
    bookingComponents: BookingComponent.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingComponent
 */
export class BookingComponent implements GrpcMessage {
  static id = 'booking_platform.v1.BookingComponent';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingComponent();
    BookingComponent.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingComponent) {
    _instance.bookingComponentReference =
      _instance.bookingComponentReference || '';
    _instance.isCancellationAllowed = _instance.isCancellationAllowed || false;
    _instance.cancellationFee = _instance.cancellationFee || undefined;
    _instance.customerCancellationReasons =
      _instance.customerCancellationReasons || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingComponent,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingComponentReference = _reader.readString();
          break;
        case 2:
          _instance.isCancellationAllowed = _reader.readBool();
          break;
        case 3:
          _instance.cancellationFee = new googleType000.Decimal();
          _reader.readMessage(
            _instance.cancellationFee,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        case 4:
          const messageInitializer4 = new booking_platformV1Shared020.CustomerCancellationReason();
          _reader.readMessage(
            messageInitializer4,
            booking_platformV1Shared020.CustomerCancellationReason
              .deserializeBinaryFromReader
          );
          (_instance.customerCancellationReasons =
            _instance.customerCancellationReasons || []).push(
            messageInitializer4
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingComponent.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingComponent,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingComponentReference) {
      _writer.writeString(1, _instance.bookingComponentReference);
    }
    if (_instance.isCancellationAllowed) {
      _writer.writeBool(2, _instance.isCancellationAllowed);
    }
    if (_instance.cancellationFee) {
      _writer.writeMessage(
        3,
        _instance.cancellationFee as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
    if (
      _instance.customerCancellationReasons &&
      _instance.customerCancellationReasons.length
    ) {
      _writer.writeRepeatedMessage(
        4,
        _instance.customerCancellationReasons as any,
        booking_platformV1Shared020.CustomerCancellationReason
          .serializeBinaryToWriter
      );
    }
  }

  private _bookingComponentReference: string;
  private _isCancellationAllowed: boolean;
  private _cancellationFee?: googleType000.Decimal;
  private _customerCancellationReasons?: booking_platformV1Shared020.CustomerCancellationReason[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingComponent to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingComponent.AsObject>) {
    _value = _value || {};
    this.bookingComponentReference = _value.bookingComponentReference;
    this.isCancellationAllowed = _value.isCancellationAllowed;
    this.cancellationFee = _value.cancellationFee
      ? new googleType000.Decimal(_value.cancellationFee)
      : undefined;
    this.customerCancellationReasons = (
      _value.customerCancellationReasons || []
    ).map(m => new booking_platformV1Shared020.CustomerCancellationReason(m));
    BookingComponent.refineValues(this);
  }
  get bookingComponentReference(): string {
    return this._bookingComponentReference;
  }
  set bookingComponentReference(value: string) {
    this._bookingComponentReference = value;
  }
  get isCancellationAllowed(): boolean {
    return this._isCancellationAllowed;
  }
  set isCancellationAllowed(value: boolean) {
    this._isCancellationAllowed = value;
  }
  get cancellationFee(): googleType000.Decimal | undefined {
    return this._cancellationFee;
  }
  set cancellationFee(value: googleType000.Decimal | undefined) {
    this._cancellationFee = value;
  }
  get customerCancellationReasons():
    | booking_platformV1Shared020.CustomerCancellationReason[]
    | undefined {
    return this._customerCancellationReasons;
  }
  set customerCancellationReasons(
    value: booking_platformV1Shared020.CustomerCancellationReason[] | undefined
  ) {
    this._customerCancellationReasons = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingComponent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingComponent.AsObject {
    return {
      bookingComponentReference: this.bookingComponentReference,
      isCancellationAllowed: this.isCancellationAllowed,
      cancellationFee: this.cancellationFee
        ? this.cancellationFee.toObject()
        : undefined,
      customerCancellationReasons: (
        this.customerCancellationReasons || []
      ).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingComponent.AsProtobufJSON {
    return {
      bookingComponentReference: this.bookingComponentReference,
      isCancellationAllowed: this.isCancellationAllowed,
      cancellationFee: this.cancellationFee
        ? this.cancellationFee.toProtobufJSON(options)
        : null,
      customerCancellationReasons: (
        this.customerCancellationReasons || []
      ).map(m => m.toProtobufJSON(options))
    };
  }
}
export module BookingComponent {
  /**
   * Standard JavaScript object representation for BookingComponent
   */
  export interface AsObject {
    bookingComponentReference: string;
    isCancellationAllowed: boolean;
    cancellationFee?: googleType000.Decimal.AsObject;
    customerCancellationReasons?: booking_platformV1Shared020.CustomerCancellationReason.AsObject[];
  }

  /**
   * Protobuf JSON representation for BookingComponent
   */
  export interface AsProtobufJSON {
    bookingComponentReference: string;
    isCancellationAllowed: boolean;
    cancellationFee: googleType000.Decimal.AsProtobufJSON | null;
    customerCancellationReasons:
      | booking_platformV1Shared020.CustomerCancellationReason.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.CancelRequest
 */
export class CancelRequest implements GrpcMessage {
  static id = 'booking_platform.v1.CancelRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancelRequest();
    CancelRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancelRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.bookingReference = _instance.bookingReference || '';
    _instance.bookingComponents = _instance.bookingComponents || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancelRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.bookingReference = _reader.readString();
          break;
        case 5:
          const messageInitializer5 = new CancellationItem();
          _reader.readMessage(
            messageInitializer5,
            CancellationItem.deserializeBinaryFromReader
          );
          (_instance.bookingComponents =
            _instance.bookingComponents || []).push(messageInitializer5);
          break;
        default:
          _reader.skipField();
      }
    }

    CancelRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancelRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.bookingReference) {
      _writer.writeString(4, _instance.bookingReference);
    }
    if (_instance.bookingComponents && _instance.bookingComponents.length) {
      _writer.writeRepeatedMessage(
        5,
        _instance.bookingComponents as any,
        CancellationItem.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _bookingReference: string;
  private _bookingComponents?: CancellationItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancelRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancelRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.bookingReference = _value.bookingReference;
    this.bookingComponents = (_value.bookingComponents || []).map(
      m => new CancellationItem(m)
    );
    CancelRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get bookingReference(): string {
    return this._bookingReference;
  }
  set bookingReference(value: string) {
    this._bookingReference = value;
  }
  get bookingComponents(): CancellationItem[] | undefined {
    return this._bookingComponents;
  }
  set bookingComponents(value: CancellationItem[] | undefined) {
    this._bookingComponents = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancelRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancelRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingReference: this.bookingReference,
      bookingComponents: (this.bookingComponents || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancelRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      bookingReference: this.bookingReference,
      bookingComponents: (this.bookingComponents || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module CancelRequest {
  /**
   * Standard JavaScript object representation for CancelRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingReference: string;
    bookingComponents?: CancellationItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for CancelRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    bookingReference: string;
    bookingComponents: CancellationItem.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.CancelResponse
 */
export class CancelResponse implements GrpcMessage {
  static id = 'booking_platform.v1.CancelResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancelResponse();
    CancelResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancelResponse) {
    _instance.bookingReference = _instance.bookingReference || '';
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.bookingComponents = _instance.bookingComponents || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancelResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingReference = _reader.readString();
          break;
        case 2:
          _instance.currencyCode = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new CancellationResult();
          _reader.readMessage(
            messageInitializer3,
            CancellationResult.deserializeBinaryFromReader
          );
          (_instance.bookingComponents =
            _instance.bookingComponents || []).push(messageInitializer3);
          break;
        default:
          _reader.skipField();
      }
    }

    CancelResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancelResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingReference) {
      _writer.writeString(1, _instance.bookingReference);
    }
    if (_instance.currencyCode) {
      _writer.writeString(2, _instance.currencyCode);
    }
    if (_instance.bookingComponents && _instance.bookingComponents.length) {
      _writer.writeRepeatedMessage(
        3,
        _instance.bookingComponents as any,
        CancellationResult.serializeBinaryToWriter
      );
    }
  }

  private _bookingReference: string;
  private _currencyCode: string;
  private _bookingComponents?: CancellationResult[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancelResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancelResponse.AsObject>) {
    _value = _value || {};
    this.bookingReference = _value.bookingReference;
    this.currencyCode = _value.currencyCode;
    this.bookingComponents = (_value.bookingComponents || []).map(
      m => new CancellationResult(m)
    );
    CancelResponse.refineValues(this);
  }
  get bookingReference(): string {
    return this._bookingReference;
  }
  set bookingReference(value: string) {
    this._bookingReference = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get bookingComponents(): CancellationResult[] | undefined {
    return this._bookingComponents;
  }
  set bookingComponents(value: CancellationResult[] | undefined) {
    this._bookingComponents = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancelResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancelResponse.AsObject {
    return {
      bookingReference: this.bookingReference,
      currencyCode: this.currencyCode,
      bookingComponents: (this.bookingComponents || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancelResponse.AsProtobufJSON {
    return {
      bookingReference: this.bookingReference,
      currencyCode: this.currencyCode,
      bookingComponents: (this.bookingComponents || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module CancelResponse {
  /**
   * Standard JavaScript object representation for CancelResponse
   */
  export interface AsObject {
    bookingReference: string;
    currencyCode: string;
    bookingComponents?: CancellationResult.AsObject[];
  }

  /**
   * Protobuf JSON representation for CancelResponse
   */
  export interface AsProtobufJSON {
    bookingReference: string;
    currencyCode: string;
    bookingComponents: CancellationResult.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.CancellationItem
 */
export class CancellationItem implements GrpcMessage {
  static id = 'booking_platform.v1.CancellationItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancellationItem();
    CancellationItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancellationItem) {
    _instance.bookingComponentReference =
      _instance.bookingComponentReference || '';
    _instance.cancellationReasonCode =
      _instance.cancellationReasonCode || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancellationItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingComponentReference = _reader.readString();
          break;
        case 2:
          _instance.cancellationReasonCode = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.cancellationReasonCode,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    CancellationItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancellationItem,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingComponentReference) {
      _writer.writeString(1, _instance.bookingComponentReference);
    }
    if (_instance.cancellationReasonCode) {
      _writer.writeMessage(
        2,
        _instance.cancellationReasonCode as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _bookingComponentReference: string;
  private _cancellationReasonCode?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancellationItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancellationItem.AsObject>) {
    _value = _value || {};
    this.bookingComponentReference = _value.bookingComponentReference;
    this.cancellationReasonCode = _value.cancellationReasonCode
      ? new googleProtobuf001.StringValue(_value.cancellationReasonCode)
      : undefined;
    CancellationItem.refineValues(this);
  }
  get bookingComponentReference(): string {
    return this._bookingComponentReference;
  }
  set bookingComponentReference(value: string) {
    this._bookingComponentReference = value;
  }
  get cancellationReasonCode(): googleProtobuf001.StringValue | undefined {
    return this._cancellationReasonCode;
  }
  set cancellationReasonCode(value: googleProtobuf001.StringValue | undefined) {
    this._cancellationReasonCode = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancellationItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancellationItem.AsObject {
    return {
      bookingComponentReference: this.bookingComponentReference,
      cancellationReasonCode: this.cancellationReasonCode
        ? this.cancellationReasonCode.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancellationItem.AsProtobufJSON {
    return {
      bookingComponentReference: this.bookingComponentReference,
      cancellationReasonCode: this.cancellationReasonCode
        ? this.cancellationReasonCode.toProtobufJSON(options)
        : null
    };
  }
}
export module CancellationItem {
  /**
   * Standard JavaScript object representation for CancellationItem
   */
  export interface AsObject {
    bookingComponentReference: string;
    cancellationReasonCode?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for CancellationItem
   */
  export interface AsProtobufJSON {
    bookingComponentReference: string;
    cancellationReasonCode: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.CancellationResult
 */
export class CancellationResult implements GrpcMessage {
  static id = 'booking_platform.v1.CancellationResult';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CancellationResult();
    CancellationResult.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CancellationResult) {
    _instance.bookingComponentReference =
      _instance.bookingComponentReference || '';
    _instance.cancellationStatus = _instance.cancellationStatus || 0;
    _instance.reasonForDecline = _instance.reasonForDecline || undefined;
    _instance.cancellationFee = _instance.cancellationFee || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CancellationResult,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingComponentReference = _reader.readString();
          break;
        case 2:
          _instance.cancellationStatus = _reader.readEnum();
          break;
        case 3:
          _instance.reasonForDecline = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.reasonForDecline,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.cancellationFee = new googleType000.Decimal();
          _reader.readMessage(
            _instance.cancellationFee,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    CancellationResult.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CancellationResult,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingComponentReference) {
      _writer.writeString(1, _instance.bookingComponentReference);
    }
    if (_instance.cancellationStatus) {
      _writer.writeEnum(2, _instance.cancellationStatus);
    }
    if (_instance.reasonForDecline) {
      _writer.writeMessage(
        3,
        _instance.reasonForDecline as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.cancellationFee) {
      _writer.writeMessage(
        4,
        _instance.cancellationFee as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
  }

  private _bookingComponentReference: string;
  private _cancellationStatus: booking_platformV1Shared021.CancellationStatus;
  private _reasonForDecline?: googleProtobuf001.StringValue;
  private _cancellationFee?: googleType000.Decimal;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CancellationResult to deeply clone from
   */
  constructor(_value?: RecursivePartial<CancellationResult.AsObject>) {
    _value = _value || {};
    this.bookingComponentReference = _value.bookingComponentReference;
    this.cancellationStatus = _value.cancellationStatus;
    this.reasonForDecline = _value.reasonForDecline
      ? new googleProtobuf001.StringValue(_value.reasonForDecline)
      : undefined;
    this.cancellationFee = _value.cancellationFee
      ? new googleType000.Decimal(_value.cancellationFee)
      : undefined;
    CancellationResult.refineValues(this);
  }
  get bookingComponentReference(): string {
    return this._bookingComponentReference;
  }
  set bookingComponentReference(value: string) {
    this._bookingComponentReference = value;
  }
  get cancellationStatus(): booking_platformV1Shared021.CancellationStatus {
    return this._cancellationStatus;
  }
  set cancellationStatus(
    value: booking_platformV1Shared021.CancellationStatus
  ) {
    this._cancellationStatus = value;
  }
  get reasonForDecline(): googleProtobuf001.StringValue | undefined {
    return this._reasonForDecline;
  }
  set reasonForDecline(value: googleProtobuf001.StringValue | undefined) {
    this._reasonForDecline = value;
  }
  get cancellationFee(): googleType000.Decimal | undefined {
    return this._cancellationFee;
  }
  set cancellationFee(value: googleType000.Decimal | undefined) {
    this._cancellationFee = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CancellationResult.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CancellationResult.AsObject {
    return {
      bookingComponentReference: this.bookingComponentReference,
      cancellationStatus: this.cancellationStatus,
      reasonForDecline: this.reasonForDecline
        ? this.reasonForDecline.toObject()
        : undefined,
      cancellationFee: this.cancellationFee
        ? this.cancellationFee.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CancellationResult.AsProtobufJSON {
    return {
      bookingComponentReference: this.bookingComponentReference,
      cancellationStatus:
        booking_platformV1Shared021.CancellationStatus[
          this.cancellationStatus === null ||
          this.cancellationStatus === undefined
            ? 0
            : this.cancellationStatus
        ],
      reasonForDecline: this.reasonForDecline
        ? this.reasonForDecline.toProtobufJSON(options)
        : null,
      cancellationFee: this.cancellationFee
        ? this.cancellationFee.toProtobufJSON(options)
        : null
    };
  }
}
export module CancellationResult {
  /**
   * Standard JavaScript object representation for CancellationResult
   */
  export interface AsObject {
    bookingComponentReference: string;
    cancellationStatus: booking_platformV1Shared021.CancellationStatus;
    reasonForDecline?: googleProtobuf001.StringValue.AsObject;
    cancellationFee?: googleType000.Decimal.AsObject;
  }

  /**
   * Protobuf JSON representation for CancellationResult
   */
  export interface AsProtobufJSON {
    bookingComponentReference: string;
    cancellationStatus: string;
    reasonForDecline: googleProtobuf001.StringValue.AsProtobufJSON | null;
    cancellationFee: googleType000.Decimal.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.GetBrandsAndSalesChannelsForTenantRequest
 */
export class GetBrandsAndSalesChannelsForTenantRequest implements GrpcMessage {
  static id = 'booking_platform.v1.GetBrandsAndSalesChannelsForTenantRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetBrandsAndSalesChannelsForTenantRequest();
    GetBrandsAndSalesChannelsForTenantRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetBrandsAndSalesChannelsForTenantRequest) {
    _instance.tenantId = _instance.tenantId || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetBrandsAndSalesChannelsForTenantRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    GetBrandsAndSalesChannelsForTenantRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetBrandsAndSalesChannelsForTenantRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
  }

  private _tenantId: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetBrandsAndSalesChannelsForTenantRequest to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<
      GetBrandsAndSalesChannelsForTenantRequest.AsObject
    >
  ) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    GetBrandsAndSalesChannelsForTenantRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetBrandsAndSalesChannelsForTenantRequest.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetBrandsAndSalesChannelsForTenantRequest.AsObject {
    return {
      tenantId: this.tenantId
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetBrandsAndSalesChannelsForTenantRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId
    };
  }
}
export module GetBrandsAndSalesChannelsForTenantRequest {
  /**
   * Standard JavaScript object representation for GetBrandsAndSalesChannelsForTenantRequest
   */
  export interface AsObject {
    tenantId: string;
  }

  /**
   * Protobuf JSON representation for GetBrandsAndSalesChannelsForTenantRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
  }
}

/**
 * Message implementation for booking_platform.v1.BrandId
 */
export class BrandId implements GrpcMessage {
  static id = 'booking_platform.v1.BrandId';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BrandId();
    BrandId.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BrandId) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BrandId,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    BrandId.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(_instance: BrandId, _writer: BinaryWriter) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _id: number;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BrandId to deeply clone from
   */
  constructor(_value?: RecursivePartial<BrandId.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    BrandId.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BrandId.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BrandId.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BrandId.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name
    };
  }
}
export module BrandId {
  /**
   * Standard JavaScript object representation for BrandId
   */
  export interface AsObject {
    id: number;
    name: string;
  }

  /**
   * Protobuf JSON representation for BrandId
   */
  export interface AsProtobufJSON {
    id: number;
    name: string;
  }
}

/**
 * Message implementation for booking_platform.v1.SalesChannelId
 */
export class SalesChannelId implements GrpcMessage {
  static id = 'booking_platform.v1.SalesChannelId';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new SalesChannelId();
    SalesChannelId.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: SalesChannelId) {
    _instance.id = _instance.id || 0;
    _instance.name = _instance.name || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: SalesChannelId,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.id = _reader.readInt32();
          break;
        case 2:
          _instance.name = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    SalesChannelId.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: SalesChannelId,
    _writer: BinaryWriter
  ) {
    if (_instance.id) {
      _writer.writeInt32(1, _instance.id);
    }
    if (_instance.name) {
      _writer.writeString(2, _instance.name);
    }
  }

  private _id: number;
  private _name: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of SalesChannelId to deeply clone from
   */
  constructor(_value?: RecursivePartial<SalesChannelId.AsObject>) {
    _value = _value || {};
    this.id = _value.id;
    this.name = _value.name;
    SalesChannelId.refineValues(this);
  }
  get id(): number {
    return this._id;
  }
  set id(value: number) {
    this._id = value;
  }
  get name(): string {
    return this._name;
  }
  set name(value: string) {
    this._name = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    SalesChannelId.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): SalesChannelId.AsObject {
    return {
      id: this.id,
      name: this.name
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): SalesChannelId.AsProtobufJSON {
    return {
      id: this.id,
      name: this.name
    };
  }
}
export module SalesChannelId {
  /**
   * Standard JavaScript object representation for SalesChannelId
   */
  export interface AsObject {
    id: number;
    name: string;
  }

  /**
   * Protobuf JSON representation for SalesChannelId
   */
  export interface AsProtobufJSON {
    id: number;
    name: string;
  }
}

/**
 * Message implementation for booking_platform.v1.GetBrandsAndSalesChannelsForTenantResponse
 */
export class GetBrandsAndSalesChannelsForTenantResponse implements GrpcMessage {
  static id = 'booking_platform.v1.GetBrandsAndSalesChannelsForTenantResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new GetBrandsAndSalesChannelsForTenantResponse();
    GetBrandsAndSalesChannelsForTenantResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: GetBrandsAndSalesChannelsForTenantResponse) {
    _instance.brandIds = _instance.brandIds || [];
    _instance.salesChannelIds = _instance.salesChannelIds || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: GetBrandsAndSalesChannelsForTenantResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new BrandId();
          _reader.readMessage(
            messageInitializer1,
            BrandId.deserializeBinaryFromReader
          );
          (_instance.brandIds = _instance.brandIds || []).push(
            messageInitializer1
          );
          break;
        case 2:
          const messageInitializer2 = new SalesChannelId();
          _reader.readMessage(
            messageInitializer2,
            SalesChannelId.deserializeBinaryFromReader
          );
          (_instance.salesChannelIds = _instance.salesChannelIds || []).push(
            messageInitializer2
          );
          break;
        default:
          _reader.skipField();
      }
    }

    GetBrandsAndSalesChannelsForTenantResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: GetBrandsAndSalesChannelsForTenantResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.brandIds && _instance.brandIds.length) {
      _writer.writeRepeatedMessage(
        1,
        _instance.brandIds as any,
        BrandId.serializeBinaryToWriter
      );
    }
    if (_instance.salesChannelIds && _instance.salesChannelIds.length) {
      _writer.writeRepeatedMessage(
        2,
        _instance.salesChannelIds as any,
        SalesChannelId.serializeBinaryToWriter
      );
    }
  }

  private _brandIds?: BrandId[];
  private _salesChannelIds?: SalesChannelId[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of GetBrandsAndSalesChannelsForTenantResponse to deeply clone from
   */
  constructor(
    _value?: RecursivePartial<
      GetBrandsAndSalesChannelsForTenantResponse.AsObject
    >
  ) {
    _value = _value || {};
    this.brandIds = (_value.brandIds || []).map(m => new BrandId(m));
    this.salesChannelIds = (_value.salesChannelIds || []).map(
      m => new SalesChannelId(m)
    );
    GetBrandsAndSalesChannelsForTenantResponse.refineValues(this);
  }
  get brandIds(): BrandId[] | undefined {
    return this._brandIds;
  }
  set brandIds(value: BrandId[] | undefined) {
    this._brandIds = value;
  }
  get salesChannelIds(): SalesChannelId[] | undefined {
    return this._salesChannelIds;
  }
  set salesChannelIds(value: SalesChannelId[] | undefined) {
    this._salesChannelIds = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    GetBrandsAndSalesChannelsForTenantResponse.serializeBinaryToWriter(
      this,
      writer
    );
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): GetBrandsAndSalesChannelsForTenantResponse.AsObject {
    return {
      brandIds: (this.brandIds || []).map(m => m.toObject()),
      salesChannelIds: (this.salesChannelIds || []).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): GetBrandsAndSalesChannelsForTenantResponse.AsProtobufJSON {
    return {
      brandIds: (this.brandIds || []).map(m => m.toProtobufJSON(options)),
      salesChannelIds: (this.salesChannelIds || []).map(m =>
        m.toProtobufJSON(options)
      )
    };
  }
}
export module GetBrandsAndSalesChannelsForTenantResponse {
  /**
   * Standard JavaScript object representation for GetBrandsAndSalesChannelsForTenantResponse
   */
  export interface AsObject {
    brandIds?: BrandId.AsObject[];
    salesChannelIds?: SalesChannelId.AsObject[];
  }

  /**
   * Protobuf JSON representation for GetBrandsAndSalesChannelsForTenantResponse
   */
  export interface AsProtobufJSON {
    brandIds: BrandId.AsProtobufJSON[] | null;
    salesChannelIds: SalesChannelId.AsProtobufJSON[] | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingSearchRequest
 */
export class BookingSearchRequest implements GrpcMessage {
  static id = 'booking_platform.v1.BookingSearchRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingSearchRequest();
    BookingSearchRequest.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingSearchRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || undefined;
    _instance.salesChannelId = _instance.salesChannelId || undefined;
    _instance.partnerBookingReference =
      _instance.partnerBookingReference || undefined;
    _instance.bookingStatus = _instance.bookingStatus || undefined;
    _instance.bookingDateFrom = _instance.bookingDateFrom || undefined;
    _instance.startDateFrom = _instance.startDateFrom || undefined;
    _instance.startDateTo = _instance.startDateTo || undefined;
    _instance.componentType = _instance.componentType || undefined;
    _instance.isCustomerCancellation =
      _instance.isCustomerCancellation || undefined;
    _instance.bookingDateTo = _instance.bookingDateTo || undefined;
    _instance.bookingReference = _instance.bookingReference || undefined;
    _instance.customerFirstName = _instance.customerFirstName || undefined;
    _instance.customerLastName = _instance.customerLastName || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingSearchRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.brandId,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 3:
          _instance.salesChannelId = new googleProtobuf001.Int32Value();
          _reader.readMessage(
            _instance.salesChannelId,
            googleProtobuf001.Int32Value.deserializeBinaryFromReader
          );
          break;
        case 4:
          _instance.partnerBookingReference = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.partnerBookingReference,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 5:
          _instance.bookingStatus = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.bookingStatus,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.bookingDateFrom = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.bookingDateFrom,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.startDateFrom = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.startDateFrom,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.startDateTo = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.startDateTo,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 9:
          _instance.componentType = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.componentType,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 10:
          _instance.isCustomerCancellation = new googleProtobuf001.BoolValue();
          _reader.readMessage(
            _instance.isCustomerCancellation,
            googleProtobuf001.BoolValue.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.bookingDateTo = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.bookingDateTo,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 12:
          _instance.bookingReference = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.bookingReference,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 13:
          _instance.customerFirstName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.customerFirstName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 14:
          _instance.customerLastName = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.customerLastName,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingSearchRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingSearchRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeMessage(
        2,
        _instance.brandId as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.salesChannelId) {
      _writer.writeMessage(
        3,
        _instance.salesChannelId as any,
        googleProtobuf001.Int32Value.serializeBinaryToWriter
      );
    }
    if (_instance.partnerBookingReference) {
      _writer.writeMessage(
        4,
        _instance.partnerBookingReference as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.bookingStatus) {
      _writer.writeMessage(
        5,
        _instance.bookingStatus as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.bookingDateFrom) {
      _writer.writeMessage(
        6,
        _instance.bookingDateFrom as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.startDateFrom) {
      _writer.writeMessage(
        7,
        _instance.startDateFrom as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.startDateTo) {
      _writer.writeMessage(
        8,
        _instance.startDateTo as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.componentType) {
      _writer.writeMessage(
        9,
        _instance.componentType as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.isCustomerCancellation) {
      _writer.writeMessage(
        10,
        _instance.isCustomerCancellation as any,
        googleProtobuf001.BoolValue.serializeBinaryToWriter
      );
    }
    if (_instance.bookingDateTo) {
      _writer.writeMessage(
        11,
        _instance.bookingDateTo as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.bookingReference) {
      _writer.writeMessage(
        12,
        _instance.bookingReference as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.customerFirstName) {
      _writer.writeMessage(
        13,
        _instance.customerFirstName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.customerLastName) {
      _writer.writeMessage(
        14,
        _instance.customerLastName as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId?: googleProtobuf001.Int32Value;
  private _salesChannelId?: googleProtobuf001.Int32Value;
  private _partnerBookingReference?: googleProtobuf001.StringValue;
  private _bookingStatus?: googleProtobuf001.StringValue;
  private _bookingDateFrom?: googleProtobuf001.StringValue;
  private _startDateFrom?: googleProtobuf001.StringValue;
  private _startDateTo?: googleProtobuf001.StringValue;
  private _componentType?: googleProtobuf001.StringValue;
  private _isCustomerCancellation?: googleProtobuf001.BoolValue;
  private _bookingDateTo?: googleProtobuf001.StringValue;
  private _bookingReference?: googleProtobuf001.StringValue;
  private _customerFirstName?: googleProtobuf001.StringValue;
  private _customerLastName?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingSearchRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingSearchRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId
      ? new googleProtobuf001.Int32Value(_value.brandId)
      : undefined;
    this.salesChannelId = _value.salesChannelId
      ? new googleProtobuf001.Int32Value(_value.salesChannelId)
      : undefined;
    this.partnerBookingReference = _value.partnerBookingReference
      ? new googleProtobuf001.StringValue(_value.partnerBookingReference)
      : undefined;
    this.bookingStatus = _value.bookingStatus
      ? new googleProtobuf001.StringValue(_value.bookingStatus)
      : undefined;
    this.bookingDateFrom = _value.bookingDateFrom
      ? new googleProtobuf001.StringValue(_value.bookingDateFrom)
      : undefined;
    this.startDateFrom = _value.startDateFrom
      ? new googleProtobuf001.StringValue(_value.startDateFrom)
      : undefined;
    this.startDateTo = _value.startDateTo
      ? new googleProtobuf001.StringValue(_value.startDateTo)
      : undefined;
    this.componentType = _value.componentType
      ? new googleProtobuf001.StringValue(_value.componentType)
      : undefined;
    this.isCustomerCancellation = _value.isCustomerCancellation
      ? new googleProtobuf001.BoolValue(_value.isCustomerCancellation)
      : undefined;
    this.bookingDateTo = _value.bookingDateTo
      ? new googleProtobuf001.StringValue(_value.bookingDateTo)
      : undefined;
    this.bookingReference = _value.bookingReference
      ? new googleProtobuf001.StringValue(_value.bookingReference)
      : undefined;
    this.customerFirstName = _value.customerFirstName
      ? new googleProtobuf001.StringValue(_value.customerFirstName)
      : undefined;
    this.customerLastName = _value.customerLastName
      ? new googleProtobuf001.StringValue(_value.customerLastName)
      : undefined;
    BookingSearchRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): googleProtobuf001.Int32Value | undefined {
    return this._brandId;
  }
  set brandId(value: googleProtobuf001.Int32Value | undefined) {
    this._brandId = value;
  }
  get salesChannelId(): googleProtobuf001.Int32Value | undefined {
    return this._salesChannelId;
  }
  set salesChannelId(value: googleProtobuf001.Int32Value | undefined) {
    this._salesChannelId = value;
  }
  get partnerBookingReference(): googleProtobuf001.StringValue | undefined {
    return this._partnerBookingReference;
  }
  set partnerBookingReference(
    value: googleProtobuf001.StringValue | undefined
  ) {
    this._partnerBookingReference = value;
  }
  get bookingStatus(): googleProtobuf001.StringValue | undefined {
    return this._bookingStatus;
  }
  set bookingStatus(value: googleProtobuf001.StringValue | undefined) {
    this._bookingStatus = value;
  }
  get bookingDateFrom(): googleProtobuf001.StringValue | undefined {
    return this._bookingDateFrom;
  }
  set bookingDateFrom(value: googleProtobuf001.StringValue | undefined) {
    this._bookingDateFrom = value;
  }
  get startDateFrom(): googleProtobuf001.StringValue | undefined {
    return this._startDateFrom;
  }
  set startDateFrom(value: googleProtobuf001.StringValue | undefined) {
    this._startDateFrom = value;
  }
  get startDateTo(): googleProtobuf001.StringValue | undefined {
    return this._startDateTo;
  }
  set startDateTo(value: googleProtobuf001.StringValue | undefined) {
    this._startDateTo = value;
  }
  get componentType(): googleProtobuf001.StringValue | undefined {
    return this._componentType;
  }
  set componentType(value: googleProtobuf001.StringValue | undefined) {
    this._componentType = value;
  }
  get isCustomerCancellation(): googleProtobuf001.BoolValue | undefined {
    return this._isCustomerCancellation;
  }
  set isCustomerCancellation(value: googleProtobuf001.BoolValue | undefined) {
    this._isCustomerCancellation = value;
  }
  get bookingDateTo(): googleProtobuf001.StringValue | undefined {
    return this._bookingDateTo;
  }
  set bookingDateTo(value: googleProtobuf001.StringValue | undefined) {
    this._bookingDateTo = value;
  }
  get bookingReference(): googleProtobuf001.StringValue | undefined {
    return this._bookingReference;
  }
  set bookingReference(value: googleProtobuf001.StringValue | undefined) {
    this._bookingReference = value;
  }
  get customerFirstName(): googleProtobuf001.StringValue | undefined {
    return this._customerFirstName;
  }
  set customerFirstName(value: googleProtobuf001.StringValue | undefined) {
    this._customerFirstName = value;
  }
  get customerLastName(): googleProtobuf001.StringValue | undefined {
    return this._customerLastName;
  }
  set customerLastName(value: googleProtobuf001.StringValue | undefined) {
    this._customerLastName = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingSearchRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingSearchRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId ? this.brandId.toObject() : undefined,
      salesChannelId: this.salesChannelId
        ? this.salesChannelId.toObject()
        : undefined,
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toObject()
        : undefined,
      bookingStatus: this.bookingStatus
        ? this.bookingStatus.toObject()
        : undefined,
      bookingDateFrom: this.bookingDateFrom
        ? this.bookingDateFrom.toObject()
        : undefined,
      startDateFrom: this.startDateFrom
        ? this.startDateFrom.toObject()
        : undefined,
      startDateTo: this.startDateTo ? this.startDateTo.toObject() : undefined,
      componentType: this.componentType
        ? this.componentType.toObject()
        : undefined,
      isCustomerCancellation: this.isCustomerCancellation
        ? this.isCustomerCancellation.toObject()
        : undefined,
      bookingDateTo: this.bookingDateTo
        ? this.bookingDateTo.toObject()
        : undefined,
      bookingReference: this.bookingReference
        ? this.bookingReference.toObject()
        : undefined,
      customerFirstName: this.customerFirstName
        ? this.customerFirstName.toObject()
        : undefined,
      customerLastName: this.customerLastName
        ? this.customerLastName.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingSearchRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId ? this.brandId.toProtobufJSON(options) : null,
      salesChannelId: this.salesChannelId
        ? this.salesChannelId.toProtobufJSON(options)
        : null,
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toProtobufJSON(options)
        : null,
      bookingStatus: this.bookingStatus
        ? this.bookingStatus.toProtobufJSON(options)
        : null,
      bookingDateFrom: this.bookingDateFrom
        ? this.bookingDateFrom.toProtobufJSON(options)
        : null,
      startDateFrom: this.startDateFrom
        ? this.startDateFrom.toProtobufJSON(options)
        : null,
      startDateTo: this.startDateTo
        ? this.startDateTo.toProtobufJSON(options)
        : null,
      componentType: this.componentType
        ? this.componentType.toProtobufJSON(options)
        : null,
      isCustomerCancellation: this.isCustomerCancellation
        ? this.isCustomerCancellation.toProtobufJSON(options)
        : null,
      bookingDateTo: this.bookingDateTo
        ? this.bookingDateTo.toProtobufJSON(options)
        : null,
      bookingReference: this.bookingReference
        ? this.bookingReference.toProtobufJSON(options)
        : null,
      customerFirstName: this.customerFirstName
        ? this.customerFirstName.toProtobufJSON(options)
        : null,
      customerLastName: this.customerLastName
        ? this.customerLastName.toProtobufJSON(options)
        : null
    };
  }
}
export module BookingSearchRequest {
  /**
   * Standard JavaScript object representation for BookingSearchRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId?: googleProtobuf001.Int32Value.AsObject;
    salesChannelId?: googleProtobuf001.Int32Value.AsObject;
    partnerBookingReference?: googleProtobuf001.StringValue.AsObject;
    bookingStatus?: googleProtobuf001.StringValue.AsObject;
    bookingDateFrom?: googleProtobuf001.StringValue.AsObject;
    startDateFrom?: googleProtobuf001.StringValue.AsObject;
    startDateTo?: googleProtobuf001.StringValue.AsObject;
    componentType?: googleProtobuf001.StringValue.AsObject;
    isCustomerCancellation?: googleProtobuf001.BoolValue.AsObject;
    bookingDateTo?: googleProtobuf001.StringValue.AsObject;
    bookingReference?: googleProtobuf001.StringValue.AsObject;
    customerFirstName?: googleProtobuf001.StringValue.AsObject;
    customerLastName?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for BookingSearchRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    salesChannelId: googleProtobuf001.Int32Value.AsProtobufJSON | null;
    partnerBookingReference: googleProtobuf001.StringValue.AsProtobufJSON | null;
    bookingStatus: googleProtobuf001.StringValue.AsProtobufJSON | null;
    bookingDateFrom: googleProtobuf001.StringValue.AsProtobufJSON | null;
    startDateFrom: googleProtobuf001.StringValue.AsProtobufJSON | null;
    startDateTo: googleProtobuf001.StringValue.AsProtobufJSON | null;
    componentType: googleProtobuf001.StringValue.AsProtobufJSON | null;
    isCustomerCancellation: googleProtobuf001.BoolValue.AsProtobufJSON | null;
    bookingDateTo: googleProtobuf001.StringValue.AsProtobufJSON | null;
    bookingReference: googleProtobuf001.StringValue.AsProtobufJSON | null;
    customerFirstName: googleProtobuf001.StringValue.AsProtobufJSON | null;
    customerLastName: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingSearchResponseItem
 */
export class BookingSearchResponseItem implements GrpcMessage {
  static id = 'booking_platform.v1.BookingSearchResponseItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingSearchResponseItem();
    BookingSearchResponseItem.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingSearchResponseItem) {
    _instance.bookingReference = _instance.bookingReference || '';
    _instance.brandName = _instance.brandName || '';
    _instance.salesChannelName = _instance.salesChannelName || '';
    _instance.bookingStatus = _instance.bookingStatus || '';
    _instance.partnerBookingReference =
      _instance.partnerBookingReference || undefined;
    _instance.bookingDate = _instance.bookingDate || '';
    _instance.customerFirstName = _instance.customerFirstName || '';
    _instance.customerLastName = _instance.customerLastName || '';
    _instance.startDate = _instance.startDate || '';
    _instance.endDate = _instance.endDate || undefined;
    _instance.currencyCode = _instance.currencyCode || '';
    _instance.totalPrice = _instance.totalPrice || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingSearchResponseItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingReference = _reader.readString();
          break;
        case 2:
          _instance.brandName = _reader.readString();
          break;
        case 3:
          _instance.salesChannelName = _reader.readString();
          break;
        case 4:
          _instance.bookingStatus = _reader.readString();
          break;
        case 5:
          _instance.partnerBookingReference = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.partnerBookingReference,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 6:
          _instance.bookingDate = _reader.readString();
          break;
        case 7:
          _instance.customerFirstName = _reader.readString();
          break;
        case 8:
          _instance.customerLastName = _reader.readString();
          break;
        case 9:
          _instance.startDate = _reader.readString();
          break;
        case 10:
          _instance.endDate = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.endDate,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 11:
          _instance.currencyCode = _reader.readString();
          break;
        case 12:
          _instance.totalPrice = new googleType000.Decimal();
          _reader.readMessage(
            _instance.totalPrice,
            googleType000.Decimal.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingSearchResponseItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingSearchResponseItem,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingReference) {
      _writer.writeString(1, _instance.bookingReference);
    }
    if (_instance.brandName) {
      _writer.writeString(2, _instance.brandName);
    }
    if (_instance.salesChannelName) {
      _writer.writeString(3, _instance.salesChannelName);
    }
    if (_instance.bookingStatus) {
      _writer.writeString(4, _instance.bookingStatus);
    }
    if (_instance.partnerBookingReference) {
      _writer.writeMessage(
        5,
        _instance.partnerBookingReference as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.bookingDate) {
      _writer.writeString(6, _instance.bookingDate);
    }
    if (_instance.customerFirstName) {
      _writer.writeString(7, _instance.customerFirstName);
    }
    if (_instance.customerLastName) {
      _writer.writeString(8, _instance.customerLastName);
    }
    if (_instance.startDate) {
      _writer.writeString(9, _instance.startDate);
    }
    if (_instance.endDate) {
      _writer.writeMessage(
        10,
        _instance.endDate as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.currencyCode) {
      _writer.writeString(11, _instance.currencyCode);
    }
    if (_instance.totalPrice) {
      _writer.writeMessage(
        12,
        _instance.totalPrice as any,
        googleType000.Decimal.serializeBinaryToWriter
      );
    }
  }

  private _bookingReference: string;
  private _brandName: string;
  private _salesChannelName: string;
  private _bookingStatus: string;
  private _partnerBookingReference?: googleProtobuf001.StringValue;
  private _bookingDate: string;
  private _customerFirstName: string;
  private _customerLastName: string;
  private _startDate: string;
  private _endDate?: googleProtobuf001.StringValue;
  private _currencyCode: string;
  private _totalPrice?: googleType000.Decimal;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingSearchResponseItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingSearchResponseItem.AsObject>) {
    _value = _value || {};
    this.bookingReference = _value.bookingReference;
    this.brandName = _value.brandName;
    this.salesChannelName = _value.salesChannelName;
    this.bookingStatus = _value.bookingStatus;
    this.partnerBookingReference = _value.partnerBookingReference
      ? new googleProtobuf001.StringValue(_value.partnerBookingReference)
      : undefined;
    this.bookingDate = _value.bookingDate;
    this.customerFirstName = _value.customerFirstName;
    this.customerLastName = _value.customerLastName;
    this.startDate = _value.startDate;
    this.endDate = _value.endDate
      ? new googleProtobuf001.StringValue(_value.endDate)
      : undefined;
    this.currencyCode = _value.currencyCode;
    this.totalPrice = _value.totalPrice
      ? new googleType000.Decimal(_value.totalPrice)
      : undefined;
    BookingSearchResponseItem.refineValues(this);
  }
  get bookingReference(): string {
    return this._bookingReference;
  }
  set bookingReference(value: string) {
    this._bookingReference = value;
  }
  get brandName(): string {
    return this._brandName;
  }
  set brandName(value: string) {
    this._brandName = value;
  }
  get salesChannelName(): string {
    return this._salesChannelName;
  }
  set salesChannelName(value: string) {
    this._salesChannelName = value;
  }
  get bookingStatus(): string {
    return this._bookingStatus;
  }
  set bookingStatus(value: string) {
    this._bookingStatus = value;
  }
  get partnerBookingReference(): googleProtobuf001.StringValue | undefined {
    return this._partnerBookingReference;
  }
  set partnerBookingReference(
    value: googleProtobuf001.StringValue | undefined
  ) {
    this._partnerBookingReference = value;
  }
  get bookingDate(): string {
    return this._bookingDate;
  }
  set bookingDate(value: string) {
    this._bookingDate = value;
  }
  get customerFirstName(): string {
    return this._customerFirstName;
  }
  set customerFirstName(value: string) {
    this._customerFirstName = value;
  }
  get customerLastName(): string {
    return this._customerLastName;
  }
  set customerLastName(value: string) {
    this._customerLastName = value;
  }
  get startDate(): string {
    return this._startDate;
  }
  set startDate(value: string) {
    this._startDate = value;
  }
  get endDate(): googleProtobuf001.StringValue | undefined {
    return this._endDate;
  }
  set endDate(value: googleProtobuf001.StringValue | undefined) {
    this._endDate = value;
  }
  get currencyCode(): string {
    return this._currencyCode;
  }
  set currencyCode(value: string) {
    this._currencyCode = value;
  }
  get totalPrice(): googleType000.Decimal | undefined {
    return this._totalPrice;
  }
  set totalPrice(value: googleType000.Decimal | undefined) {
    this._totalPrice = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingSearchResponseItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingSearchResponseItem.AsObject {
    return {
      bookingReference: this.bookingReference,
      brandName: this.brandName,
      salesChannelName: this.salesChannelName,
      bookingStatus: this.bookingStatus,
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toObject()
        : undefined,
      bookingDate: this.bookingDate,
      customerFirstName: this.customerFirstName,
      customerLastName: this.customerLastName,
      startDate: this.startDate,
      endDate: this.endDate ? this.endDate.toObject() : undefined,
      currencyCode: this.currencyCode,
      totalPrice: this.totalPrice ? this.totalPrice.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingSearchResponseItem.AsProtobufJSON {
    return {
      bookingReference: this.bookingReference,
      brandName: this.brandName,
      salesChannelName: this.salesChannelName,
      bookingStatus: this.bookingStatus,
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toProtobufJSON(options)
        : null,
      bookingDate: this.bookingDate,
      customerFirstName: this.customerFirstName,
      customerLastName: this.customerLastName,
      startDate: this.startDate,
      endDate: this.endDate ? this.endDate.toProtobufJSON(options) : null,
      currencyCode: this.currencyCode,
      totalPrice: this.totalPrice
        ? this.totalPrice.toProtobufJSON(options)
        : null
    };
  }
}
export module BookingSearchResponseItem {
  /**
   * Standard JavaScript object representation for BookingSearchResponseItem
   */
  export interface AsObject {
    bookingReference: string;
    brandName: string;
    salesChannelName: string;
    bookingStatus: string;
    partnerBookingReference?: googleProtobuf001.StringValue.AsObject;
    bookingDate: string;
    customerFirstName: string;
    customerLastName: string;
    startDate: string;
    endDate?: googleProtobuf001.StringValue.AsObject;
    currencyCode: string;
    totalPrice?: googleType000.Decimal.AsObject;
  }

  /**
   * Protobuf JSON representation for BookingSearchResponseItem
   */
  export interface AsProtobufJSON {
    bookingReference: string;
    brandName: string;
    salesChannelName: string;
    bookingStatus: string;
    partnerBookingReference: googleProtobuf001.StringValue.AsProtobufJSON | null;
    bookingDate: string;
    customerFirstName: string;
    customerLastName: string;
    startDate: string;
    endDate: googleProtobuf001.StringValue.AsProtobufJSON | null;
    currencyCode: string;
    totalPrice: googleType000.Decimal.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingSearchResponse
 */
export class BookingSearchResponse implements GrpcMessage {
  static id = 'booking_platform.v1.BookingSearchResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingSearchResponse();
    BookingSearchResponse.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingSearchResponse) {
    _instance.bookingSearchResponseItems =
      _instance.bookingSearchResponseItems || [];
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingSearchResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          const messageInitializer1 = new BookingSearchResponseItem();
          _reader.readMessage(
            messageInitializer1,
            BookingSearchResponseItem.deserializeBinaryFromReader
          );
          (_instance.bookingSearchResponseItems =
            _instance.bookingSearchResponseItems || []).push(
            messageInitializer1
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingSearchResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingSearchResponse,
    _writer: BinaryWriter
  ) {
    if (
      _instance.bookingSearchResponseItems &&
      _instance.bookingSearchResponseItems.length
    ) {
      _writer.writeRepeatedMessage(
        1,
        _instance.bookingSearchResponseItems as any,
        BookingSearchResponseItem.serializeBinaryToWriter
      );
    }
  }

  private _bookingSearchResponseItems?: BookingSearchResponseItem[];

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingSearchResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingSearchResponse.AsObject>) {
    _value = _value || {};
    this.bookingSearchResponseItems = (
      _value.bookingSearchResponseItems || []
    ).map(m => new BookingSearchResponseItem(m));
    BookingSearchResponse.refineValues(this);
  }
  get bookingSearchResponseItems(): BookingSearchResponseItem[] | undefined {
    return this._bookingSearchResponseItems;
  }
  set bookingSearchResponseItems(
    value: BookingSearchResponseItem[] | undefined
  ) {
    this._bookingSearchResponseItems = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingSearchResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingSearchResponse.AsObject {
    return {
      bookingSearchResponseItems: (
        this.bookingSearchResponseItems || []
      ).map(m => m.toObject())
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingSearchResponse.AsProtobufJSON {
    return {
      bookingSearchResponseItems: (
        this.bookingSearchResponseItems || []
      ).map(m => m.toProtobufJSON(options))
    };
  }
}
export module BookingSearchResponse {
  /**
   * Standard JavaScript object representation for BookingSearchResponse
   */
  export interface AsObject {
    bookingSearchResponseItems?: BookingSearchResponseItem.AsObject[];
  }

  /**
   * Protobuf JSON representation for BookingSearchResponse
   */
  export interface AsProtobufJSON {
    bookingSearchResponseItems:
      | BookingSearchResponseItem.AsProtobufJSON[]
      | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookingItem
 */
export class BookingItem implements GrpcMessage {
  static id = 'booking_platform.v1.BookingItem';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookingItem();
    BookingItem.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookingItem) {
    _instance.optionBookToken = _instance.optionBookToken || '';
    _instance.bookingQuestionAnswers = _instance.bookingQuestionAnswers || [];
    _instance.notes = _instance.notes || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookingItem,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.optionBookToken = _reader.readString();
          break;
        case 3:
          const messageInitializer3 = new booking_platformV1Shared015.BookingQuestionAnswer();
          _reader.readMessage(
            messageInitializer3,
            booking_platformV1Shared015.BookingQuestionAnswer
              .deserializeBinaryFromReader
          );
          (_instance.bookingQuestionAnswers =
            _instance.bookingQuestionAnswers || []).push(messageInitializer3);
          break;
        case 4:
          _instance.notes = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.notes,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookingItem.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookingItem,
    _writer: BinaryWriter
  ) {
    if (_instance.optionBookToken) {
      _writer.writeString(1, _instance.optionBookToken);
    }
    if (
      _instance.bookingQuestionAnswers &&
      _instance.bookingQuestionAnswers.length
    ) {
      _writer.writeRepeatedMessage(
        3,
        _instance.bookingQuestionAnswers as any,
        booking_platformV1Shared015.BookingQuestionAnswer
          .serializeBinaryToWriter
      );
    }
    if (_instance.notes) {
      _writer.writeMessage(
        4,
        _instance.notes as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
  }

  private _optionBookToken: string;
  private _bookingQuestionAnswers?: booking_platformV1Shared015.BookingQuestionAnswer[];
  private _notes?: googleProtobuf001.StringValue;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookingItem to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookingItem.AsObject>) {
    _value = _value || {};
    this.optionBookToken = _value.optionBookToken;
    this.bookingQuestionAnswers = (_value.bookingQuestionAnswers || []).map(
      m => new booking_platformV1Shared015.BookingQuestionAnswer(m)
    );
    this.notes = _value.notes
      ? new googleProtobuf001.StringValue(_value.notes)
      : undefined;
    BookingItem.refineValues(this);
  }
  get optionBookToken(): string {
    return this._optionBookToken;
  }
  set optionBookToken(value: string) {
    this._optionBookToken = value;
  }
  get bookingQuestionAnswers():
    | booking_platformV1Shared015.BookingQuestionAnswer[]
    | undefined {
    return this._bookingQuestionAnswers;
  }
  set bookingQuestionAnswers(
    value: booking_platformV1Shared015.BookingQuestionAnswer[] | undefined
  ) {
    this._bookingQuestionAnswers = value;
  }
  get notes(): googleProtobuf001.StringValue | undefined {
    return this._notes;
  }
  set notes(value: googleProtobuf001.StringValue | undefined) {
    this._notes = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookingItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookingItem.AsObject {
    return {
      optionBookToken: this.optionBookToken,
      bookingQuestionAnswers: (this.bookingQuestionAnswers || []).map(m =>
        m.toObject()
      ),
      notes: this.notes ? this.notes.toObject() : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookingItem.AsProtobufJSON {
    return {
      optionBookToken: this.optionBookToken,
      bookingQuestionAnswers: (this.bookingQuestionAnswers || []).map(m =>
        m.toProtobufJSON(options)
      ),
      notes: this.notes ? this.notes.toProtobufJSON(options) : null
    };
  }
}
export module BookingItem {
  /**
   * Standard JavaScript object representation for BookingItem
   */
  export interface AsObject {
    optionBookToken: string;
    bookingQuestionAnswers?: booking_platformV1Shared015.BookingQuestionAnswer.AsObject[];
    notes?: googleProtobuf001.StringValue.AsObject;
  }

  /**
   * Protobuf JSON representation for BookingItem
   */
  export interface AsProtobufJSON {
    optionBookToken: string;
    bookingQuestionAnswers:
      | booking_platformV1Shared015.BookingQuestionAnswer.AsProtobufJSON[]
      | null;
    notes: googleProtobuf001.StringValue.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.BookRequest
 */
export class BookRequest implements GrpcMessage {
  static id = 'booking_platform.v1.BookRequest';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookRequest();
    BookRequest.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookRequest) {
    _instance.tenantId = _instance.tenantId || '';
    _instance.brandId = _instance.brandId || 0;
    _instance.salesChannelId = _instance.salesChannelId || 0;
    _instance.contactInfo = _instance.contactInfo || undefined;
    _instance.bookingItems = _instance.bookingItems || [];
    _instance.partnerBookingReference =
      _instance.partnerBookingReference || undefined;
    _instance.paymentReference = _instance.paymentReference || undefined;
    _instance.creditCardInfo = _instance.creditCardInfo || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookRequest,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.tenantId = _reader.readString();
          break;
        case 2:
          _instance.brandId = _reader.readInt32();
          break;
        case 3:
          _instance.salesChannelId = _reader.readInt32();
          break;
        case 4:
          _instance.contactInfo = new booking_platformV1Shared012.ContactInfo();
          _reader.readMessage(
            _instance.contactInfo,
            booking_platformV1Shared012.ContactInfo.deserializeBinaryFromReader
          );
          break;
        case 5:
          const messageInitializer5 = new BookingItem();
          _reader.readMessage(
            messageInitializer5,
            BookingItem.deserializeBinaryFromReader
          );
          (_instance.bookingItems = _instance.bookingItems || []).push(
            messageInitializer5
          );
          break;
        case 6:
          _instance.partnerBookingReference = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.partnerBookingReference,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 7:
          _instance.paymentReference = new googleProtobuf001.StringValue();
          _reader.readMessage(
            _instance.paymentReference,
            googleProtobuf001.StringValue.deserializeBinaryFromReader
          );
          break;
        case 8:
          _instance.creditCardInfo = new CreditCardInfo();
          _reader.readMessage(
            _instance.creditCardInfo,
            CreditCardInfo.deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookRequest.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookRequest,
    _writer: BinaryWriter
  ) {
    if (_instance.tenantId) {
      _writer.writeString(1, _instance.tenantId);
    }
    if (_instance.brandId) {
      _writer.writeInt32(2, _instance.brandId);
    }
    if (_instance.salesChannelId) {
      _writer.writeInt32(3, _instance.salesChannelId);
    }
    if (_instance.contactInfo) {
      _writer.writeMessage(
        4,
        _instance.contactInfo as any,
        booking_platformV1Shared012.ContactInfo.serializeBinaryToWriter
      );
    }
    if (_instance.bookingItems && _instance.bookingItems.length) {
      _writer.writeRepeatedMessage(
        5,
        _instance.bookingItems as any,
        BookingItem.serializeBinaryToWriter
      );
    }
    if (_instance.partnerBookingReference) {
      _writer.writeMessage(
        6,
        _instance.partnerBookingReference as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.paymentReference) {
      _writer.writeMessage(
        7,
        _instance.paymentReference as any,
        googleProtobuf001.StringValue.serializeBinaryToWriter
      );
    }
    if (_instance.creditCardInfo) {
      _writer.writeMessage(
        8,
        _instance.creditCardInfo as any,
        CreditCardInfo.serializeBinaryToWriter
      );
    }
  }

  private _tenantId: string;
  private _brandId: number;
  private _salesChannelId: number;
  private _contactInfo?: booking_platformV1Shared012.ContactInfo;
  private _bookingItems?: BookingItem[];
  private _partnerBookingReference?: googleProtobuf001.StringValue;
  private _paymentReference?: googleProtobuf001.StringValue;
  private _creditCardInfo?: CreditCardInfo;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookRequest to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookRequest.AsObject>) {
    _value = _value || {};
    this.tenantId = _value.tenantId;
    this.brandId = _value.brandId;
    this.salesChannelId = _value.salesChannelId;
    this.contactInfo = _value.contactInfo
      ? new booking_platformV1Shared012.ContactInfo(_value.contactInfo)
      : undefined;
    this.bookingItems = (_value.bookingItems || []).map(
      m => new BookingItem(m)
    );
    this.partnerBookingReference = _value.partnerBookingReference
      ? new googleProtobuf001.StringValue(_value.partnerBookingReference)
      : undefined;
    this.paymentReference = _value.paymentReference
      ? new googleProtobuf001.StringValue(_value.paymentReference)
      : undefined;
    this.creditCardInfo = _value.creditCardInfo
      ? new CreditCardInfo(_value.creditCardInfo)
      : undefined;
    BookRequest.refineValues(this);
  }
  get tenantId(): string {
    return this._tenantId;
  }
  set tenantId(value: string) {
    this._tenantId = value;
  }
  get brandId(): number {
    return this._brandId;
  }
  set brandId(value: number) {
    this._brandId = value;
  }
  get salesChannelId(): number {
    return this._salesChannelId;
  }
  set salesChannelId(value: number) {
    this._salesChannelId = value;
  }
  get contactInfo(): booking_platformV1Shared012.ContactInfo | undefined {
    return this._contactInfo;
  }
  set contactInfo(value: booking_platformV1Shared012.ContactInfo | undefined) {
    this._contactInfo = value;
  }
  get bookingItems(): BookingItem[] | undefined {
    return this._bookingItems;
  }
  set bookingItems(value: BookingItem[] | undefined) {
    this._bookingItems = value;
  }
  get partnerBookingReference(): googleProtobuf001.StringValue | undefined {
    return this._partnerBookingReference;
  }
  set partnerBookingReference(
    value: googleProtobuf001.StringValue | undefined
  ) {
    this._partnerBookingReference = value;
  }
  get paymentReference(): googleProtobuf001.StringValue | undefined {
    return this._paymentReference;
  }
  set paymentReference(value: googleProtobuf001.StringValue | undefined) {
    this._paymentReference = value;
  }
  get creditCardInfo(): CreditCardInfo | undefined {
    return this._creditCardInfo;
  }
  set creditCardInfo(value: CreditCardInfo | undefined) {
    this._creditCardInfo = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookRequest.AsObject {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      contactInfo: this.contactInfo ? this.contactInfo.toObject() : undefined,
      bookingItems: (this.bookingItems || []).map(m => m.toObject()),
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toObject()
        : undefined,
      paymentReference: this.paymentReference
        ? this.paymentReference.toObject()
        : undefined,
      creditCardInfo: this.creditCardInfo
        ? this.creditCardInfo.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookRequest.AsProtobufJSON {
    return {
      tenantId: this.tenantId,
      brandId: this.brandId,
      salesChannelId: this.salesChannelId,
      contactInfo: this.contactInfo
        ? this.contactInfo.toProtobufJSON(options)
        : null,
      bookingItems: (this.bookingItems || []).map(m =>
        m.toProtobufJSON(options)
      ),
      partnerBookingReference: this.partnerBookingReference
        ? this.partnerBookingReference.toProtobufJSON(options)
        : null,
      paymentReference: this.paymentReference
        ? this.paymentReference.toProtobufJSON(options)
        : null,
      creditCardInfo: this.creditCardInfo
        ? this.creditCardInfo.toProtobufJSON(options)
        : null
    };
  }
}
export module BookRequest {
  /**
   * Standard JavaScript object representation for BookRequest
   */
  export interface AsObject {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    contactInfo?: booking_platformV1Shared012.ContactInfo.AsObject;
    bookingItems?: BookingItem.AsObject[];
    partnerBookingReference?: googleProtobuf001.StringValue.AsObject;
    paymentReference?: googleProtobuf001.StringValue.AsObject;
    creditCardInfo?: CreditCardInfo.AsObject;
  }

  /**
   * Protobuf JSON representation for BookRequest
   */
  export interface AsProtobufJSON {
    tenantId: string;
    brandId: number;
    salesChannelId: number;
    contactInfo: booking_platformV1Shared012.ContactInfo.AsProtobufJSON | null;
    bookingItems: BookingItem.AsProtobufJSON[] | null;
    partnerBookingReference: googleProtobuf001.StringValue.AsProtobufJSON | null;
    paymentReference: googleProtobuf001.StringValue.AsProtobufJSON | null;
    creditCardInfo: CreditCardInfo.AsProtobufJSON | null;
  }
}

/**
 * Message implementation for booking_platform.v1.CreditCardInfo
 */
export class CreditCardInfo implements GrpcMessage {
  static id = 'booking_platform.v1.CreditCardInfo';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new CreditCardInfo();
    CreditCardInfo.deserializeBinaryFromReader(
      instance,
      new BinaryReader(bytes)
    );
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: CreditCardInfo) {
    _instance.token = _instance.token || '';
    _instance.lastFourNumber = _instance.lastFourNumber || '';
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: CreditCardInfo,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.token = _reader.readString();
          break;
        case 2:
          _instance.lastFourNumber = _reader.readString();
          break;
        default:
          _reader.skipField();
      }
    }

    CreditCardInfo.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: CreditCardInfo,
    _writer: BinaryWriter
  ) {
    if (_instance.token) {
      _writer.writeString(1, _instance.token);
    }
    if (_instance.lastFourNumber) {
      _writer.writeString(2, _instance.lastFourNumber);
    }
  }

  private _token: string;
  private _lastFourNumber: string;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of CreditCardInfo to deeply clone from
   */
  constructor(_value?: RecursivePartial<CreditCardInfo.AsObject>) {
    _value = _value || {};
    this.token = _value.token;
    this.lastFourNumber = _value.lastFourNumber;
    CreditCardInfo.refineValues(this);
  }
  get token(): string {
    return this._token;
  }
  set token(value: string) {
    this._token = value;
  }
  get lastFourNumber(): string {
    return this._lastFourNumber;
  }
  set lastFourNumber(value: string) {
    this._lastFourNumber = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    CreditCardInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): CreditCardInfo.AsObject {
    return {
      token: this.token,
      lastFourNumber: this.lastFourNumber
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): CreditCardInfo.AsProtobufJSON {
    return {
      token: this.token,
      lastFourNumber: this.lastFourNumber
    };
  }
}
export module CreditCardInfo {
  /**
   * Standard JavaScript object representation for CreditCardInfo
   */
  export interface AsObject {
    token: string;
    lastFourNumber: string;
  }

  /**
   * Protobuf JSON representation for CreditCardInfo
   */
  export interface AsProtobufJSON {
    token: string;
    lastFourNumber: string;
  }
}

/**
 * Message implementation for booking_platform.v1.BookResponse
 */
export class BookResponse implements GrpcMessage {
  static id = 'booking_platform.v1.BookResponse';

  /**
   * Deserialize binary data to message
   * @param instance message instance
   */
  static deserializeBinary(bytes: ByteSource) {
    const instance = new BookResponse();
    BookResponse.deserializeBinaryFromReader(instance, new BinaryReader(bytes));
    return instance;
  }

  /**
   * Check all the properties and set default protobuf values if necessary
   * @param _instance message instance
   */
  static refineValues(_instance: BookResponse) {
    _instance.bookingSessionId = _instance.bookingSessionId || '';
    _instance.paymentSession = _instance.paymentSession || undefined;
  }

  /**
   * Deserializes / reads binary message into message instance using provided binary reader
   * @param _instance message instance
   * @param _reader binary reader instance
   */
  static deserializeBinaryFromReader(
    _instance: BookResponse,
    _reader: BinaryReader
  ) {
    while (_reader.nextField()) {
      if (_reader.isEndGroup()) break;

      switch (_reader.getFieldNumber()) {
        case 1:
          _instance.bookingSessionId = _reader.readString();
          break;
        case 2:
          _instance.paymentSession = new booking_platformV1Shared013.PaymentSession();
          _reader.readMessage(
            _instance.paymentSession,
            booking_platformV1Shared013.PaymentSession
              .deserializeBinaryFromReader
          );
          break;
        default:
          _reader.skipField();
      }
    }

    BookResponse.refineValues(_instance);
  }

  /**
   * Serializes a message to binary format using provided binary reader
   * @param _instance message instance
   * @param _writer binary writer instance
   */
  static serializeBinaryToWriter(
    _instance: BookResponse,
    _writer: BinaryWriter
  ) {
    if (_instance.bookingSessionId) {
      _writer.writeString(1, _instance.bookingSessionId);
    }
    if (_instance.paymentSession) {
      _writer.writeMessage(
        2,
        _instance.paymentSession as any,
        booking_platformV1Shared013.PaymentSession.serializeBinaryToWriter
      );
    }
  }

  private _bookingSessionId: string;
  private _paymentSession?: booking_platformV1Shared013.PaymentSession;

  /**
   * Message constructor. Initializes the properties and applies default Protobuf values if necessary
   * @param _value initial values object or instance of BookResponse to deeply clone from
   */
  constructor(_value?: RecursivePartial<BookResponse.AsObject>) {
    _value = _value || {};
    this.bookingSessionId = _value.bookingSessionId;
    this.paymentSession = _value.paymentSession
      ? new booking_platformV1Shared013.PaymentSession(_value.paymentSession)
      : undefined;
    BookResponse.refineValues(this);
  }
  get bookingSessionId(): string {
    return this._bookingSessionId;
  }
  set bookingSessionId(value: string) {
    this._bookingSessionId = value;
  }
  get paymentSession(): booking_platformV1Shared013.PaymentSession | undefined {
    return this._paymentSession;
  }
  set paymentSession(
    value: booking_platformV1Shared013.PaymentSession | undefined
  ) {
    this._paymentSession = value;
  }

  /**
   * Serialize message to binary data
   * @param instance message instance
   */
  serializeBinary() {
    const writer = new BinaryWriter();
    BookResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
  }

  /**
   * Cast message to standard JavaScript object (all non-primitive values are deeply cloned)
   */
  toObject(): BookResponse.AsObject {
    return {
      bookingSessionId: this.bookingSessionId,
      paymentSession: this.paymentSession
        ? this.paymentSession.toObject()
        : undefined
    };
  }

  /**
   * Convenience method to support JSON.stringify(message), replicates the structure of toObject()
   */
  toJSON() {
    return this.toObject();
  }

  /**
   * Cast message to JSON using protobuf JSON notation: https://developers.google.com/protocol-buffers/docs/proto3#json
   * Attention: output differs from toObject() e.g. enums are represented as names and not as numbers, Timestamp is an ISO Date string format etc.
   * If the message itself or some of descendant messages is google.protobuf.Any, you MUST provide a message pool as options. If not, the messagePool is not required
   */
  toProtobufJSON(
    // @ts-ignore
    options?: ToProtobufJSONOptions
  ): BookResponse.AsProtobufJSON {
    return {
      bookingSessionId: this.bookingSessionId,
      paymentSession: this.paymentSession
        ? this.paymentSession.toProtobufJSON(options)
        : null
    };
  }
}
export module BookResponse {
  /**
   * Standard JavaScript object representation for BookResponse
   */
  export interface AsObject {
    bookingSessionId: string;
    paymentSession?: booking_platformV1Shared013.PaymentSession.AsObject;
  }

  /**
   * Protobuf JSON representation for BookResponse
   */
  export interface AsProtobufJSON {
    bookingSessionId: string;
    paymentSession: booking_platformV1Shared013.PaymentSession.AsProtobufJSON | null;
  }
}
